import React, { useEffect, useState, useRef, useContext, useCallback, useMemo } from 'react';
import {
    TextField,
    Autocomplete,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    Popper,
    Tooltip,
    IconButton,
    Portal,
    Button,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    Box,
    FormControl,
    Select,
    MenuItem,
    CircularProgress,
    InputAdornment,
} from '@mui/material';
import debounce from 'lodash/debounce'
import Draggable from 'react-draggable';
import CustomDatePicker from '../../Widgets/CustomDates/CustomDatePicker/CustomDatePicker';
import SaveIcon from '@mui/icons-material/SaveAsRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SendIcon from '@mui/icons-material/Send';
import { styled } from '@mui/system';
import { PermissionsContext } from '../../../Contexts/Permissions';
import { useHamburgerMenu } from '../../../Contexts/HamburgerMenuContext';
import DocumentTransferDialog from '../../DocumentTransferDialog/DocumentTransferDialog';
import AddAccountCardModal from '../../Widgets/AddAccountCardModal/AddAccountCardModal';
import BulkEditModal from '../../PrimaryBulkActionsToolbar/BulkEditModal';
import Iframe from 'react-iframe';
import Constants from '../../../assests/Constants/constants';
import addIcon from '../../../assests/images/Icons/addIcon.svg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FilePreview } from '../../../Utils/filePreview';
import CustomMonthDatePicker from '../../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import FixedSizeVirtualizedListbox from '../../Widgets/AutocompleteCardSelect/FixedSizeVirtualizedListbox';
// IMPORTANT: set the workerSrc for react-pdf
import dayjs, { Dayjs } from 'dayjs';
import NoDocumentsPdf from "../../../assests/pdf/NoDocument.pdf";
import FilePreviewCarousel from './FilePreviewCarousel'
import PaymentAmountsSummaryBar, { computePaymentAmounts } from './PaymentAmountsSummaryBar';
import PaymentWithholdingTaxRow, { usePaymentWithholdingRow, readDeductionRate } from './PaymentWithholdingTaxRow';
import { IoArrowBackCircle, IoArrowForwardCircle } from 'react-icons/io5';
import LockIcon from '@mui/icons-material/Lock';
import Swal from 'sweetalert2';
import DocumentService from '../../../Services/documents.service';
import EnumsService from '../../../Services/enums.service';
import ReceivablesService from '../../../Services/receivables.service';
import { toast } from 'react-toastify';
import ForeignCurrencyService from '../../../Services/foreignCurrency.service';
import SubAccountantService from '../../../Services/subAccountant.service';
import ClientService from '../../../Services/client.service';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDropzone } from 'react-dropzone';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ProjectsService from '../../../Services/projects.service';
import ProjectModal from '../../Projects/ProjectModal.jsx';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import '../../EditModal/EditModal.css';
import fieldStyles from '../../JournalEntryies/SubComponents/AddJournalEntryModal.module.scss';
import paStyles from './PaymentAcceptanceCreateEditModal.module.scss';
import useCaseSystemAccountSettings from '../../../hooks/useCaseSystemAccountSettings';
import { getPaymentAcceptanceLineAccounts } from '../../../Utils/paymentAcceptanceLineAccounts';
import { canProcessDocumentStatus } from '../../../Utils/helpers';
import { getCardBankDetails, isBankPaymentType } from '../../../Utils/accountCardBankDetails';
import AccountCardBankDetailsBar from '../../Widgets/AccountCardBankDetailsBar/AccountCardBankDetailsBar';
import DocumentPreviewWithBoxes from '../../DocumentBoxViewer/DocumentPreviewWithBoxes';
import useFieldPositions from '../../DocumentBoxViewer/useFieldPositions';
import FieldBoxDot, { FieldBoxDotProvider } from '../../DocumentBoxViewer/FieldBoxDot';
import { canonical, visibleFieldSet } from '../../DocumentBoxViewer/fieldBoxes';

function getAssignedProjectIdFromItem(item) {
    if (!item) return '';
    const p = item?.projects?.[0] ?? item?.segmentations?.[0];
    if (p) {
        const id = p.projectId ?? p.ProjectId ?? p.id ?? p.Id;
        if (id != null && id !== '') return String(id);
    }
    const segId =
        item.segmentationId ??
        item.SegmentationId ??
        item.segmentationProjectId ??
        item.projectId;
    if (segId != null && segId !== '') return String(segId);
    return '';
}

function normalizeSegmentationProjectRow(p) {
    const rawId = p?.id ?? p?.Id ?? p?.projectId ?? p?.ProjectId;
    const id = rawId != null && rawId !== '' ? String(rawId) : '';
    return {
        ...p,
        id,
        code: p?.code ?? p?.Code ?? '',
        name: p?.name ?? p?.Name ?? '',
    };
}

// Helper function to render each thumbnail in the slider
const renderFilePreview = (fileUrl, idx, currentIndex, setDocIndex, t) => {
    if (idx === currentIndex) return null; // Hide the currently selected document

    return (
        <div key={idx} onClick={() => setDocIndex(idx)} style={{ cursor: 'pointer' }}>
            <FilePreview
                fileUrl={fileUrl}
                t={t}
                openPreview={() => setDocIndex(idx)} // Update document index on click
                width={100}
                height={100}
            />
        </div>
    );
};



const StyledListItem = styled('li')({
    color: '#000000',
    '&:hover': {
        cursor: 'pointer',
    },
});

const ComboPopper = React.forwardRef(({ direction = 'rtl', ...props }, ref) => (
    <Popper
        {...props}
        ref={ref}
        dir={direction}
        className={`${props.className || ''} ${fieldStyles.comboPopper} edit-modal-combo-popper ${paStyles.comboMenuBlack}`}
        placement={direction === 'rtl' ? 'bottom-end' : 'bottom-start'}
        style={{ ...props.style, zIndex: 1600, minWidth: props.style?.minWidth || 280 }}
    />
));
ComboPopper.displayName = 'ComboPopper';

function AddAccountCardOptionContent({ label, searchTerm }) {
    const text = String(label || '').trim();
    return (
        <div className="edit-add-account-card" style={{ color: '#304FFF' }}>
            <span className="edit-add-account-card__plus" aria-hidden="true" style={{ color: '#304FFF' }}>+</span>
            <span className="edit-add-account-card__label" style={{ color: '#304FFF' }}>
                {text}
                {searchTerm ? ` "${searchTerm}"` : ''}
            </span>
        </div>
    );
}

// Match JournalEntryDataGrid newEntryTooltipSx — bold, large, dark blue
const newEntryTooltipSx = {
    '& .MuiTooltip-tooltip': {
        maxWidth: 420,
        fontSize: '1.25rem',
        fontWeight: 700,
        backgroundColor: '#1a237e',
        color: '#fff',
    },
    '& .MuiTooltip-arrow': { color: '#1a237e' },
};

const clearTooltipComponentsProps = {
    tooltip: {
        sx: {
            maxWidth: 420,
            fontSize: '1.25rem',
            fontWeight: 700,
            backgroundColor: '#1a237e',
            color: '#fff',
            padding: '8px 14px',
            lineHeight: 1.35,
        },
    },
    arrow: {
        sx: { color: '#1a237e' },
    },
};

const ClearTooltip = ({ title, children, placement = 'top', ...rest }) => (
    <Tooltip
        title={title}
        placement={placement}
        arrow
        PopperProps={{ sx: newEntryTooltipSx }}
        componentsProps={clearTooltipComponentsProps}
        {...rest}
    >
        {children}
    </Tooltip>
);

const formatTooltipDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return String(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${d.getFullYear()}`;
};

// ============== STYLED TABLE COMPONENTS ==============
const StyledTableContainer = styled(TableContainer)({
    width: '100%',
    boxShadow: 'none',
    borderRadius: 0,
    maxHeight: '400px',
    overflowY: 'auto',
    background: 'transparent',
});

const StyledTable = styled(Table)({
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: '100%',
});

const StyledTableHead = styled(TableHead)({
    backgroundColor: '#E3E7FE',
    '& .MuiTableCell-head': {
        backgroundColor: '#E3E7FE',
        color: '#1222b3',
        fontFamily: 'var(--xtram-font, inherit)',
        fontSize: '12px',
        fontWeight: 700,
        textAlign: 'center',
        textTransform: 'none',
        borderBottom: '1px solid #e5e7f6',
        position: 'sticky',
        top: 0,
        padding: '10px 8px',
        zIndex: 2,
    },
});

const StyledTableRow = styled(TableRow)({
    '&:hover': {
        backgroundColor: 'rgba(48, 79, 255, 0.04)',
        transition: 'background-color 0.2s ease',
    },
});

const StyledTableCellHeader = styled(TableCell)({
    backgroundColor: '#E3E7FE',
    color: '#1222b3',
    fontFamily: 'var(--xtram-font, inherit)',
    fontSize: '12px',
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e5e7f6',
    position: 'sticky',
    top: 0,
    padding: '10px 8px',
    zIndex: 2,
});

const StyledTableCell = styled(TableCell)({
    borderTop: '1px solid #eef0f8',
    backgroundColor: '#fff',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    textAlign: 'center',
    padding: '8px 6px',
    fontSize: '13px',
    fontFamily: 'var(--xtram-font, inherit)',
    position: 'relative',
    verticalAlign: 'middle',
    '&:hover': {
        backgroundColor: 'rgba(48, 79, 255, 0.04)',
    },
});

const DragOverlayText = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '10px 20px',
    borderRadius: '5px',
    display: 'none',
});

const DropZoneContainer = styled('div')(({ isDragActive }) => ({
    width: '100%',
    textAlign: 'center',
    cursor: 'pointer',
    background: isDragActive ? '#e0e0e0' : 'transparent',
    transition: 'background 0.3s ease-in-out',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
}));

const PaymentAcceptanceCreateEditModal = ({
    openInvoiceCreatorModal,
    handleClose,
    t,
    itemEditing,
    addEditableItem,
    setPaymentDate,
    handleChangeAccountType,
    handleDescriptionChange,
    handleChangeOriginalTaxClearance,
    handleAddEditableItemChange,
    patchAddEditableItem: patchAddEditableItemProp,
    handleRadioChange,
    handleAddItem,
    handleItemChange,
    handleRemoveItem,
    accountCardOptions,
    setAccountCardOptions,
    handleSave,
    handleClickDoneCreation,
    isClosedReportingMonthAndIsRange,
    isClosedReportingMonth,
    isRange,
    handleMuiChange,
    palCode,
    setPalCode,
    client,
    setLoading: setLoadingProp,
    handleTransferRefresh,
    token,
    statusCheck,
    direction,
    handlePrevious,
    handleNext,
    currentIndex,
    filteredAndSortedData,
    fetchEnums,
    showType = { type: 'all', index: -1 },
    handleDeleteClick,
    haveNextAndPrevuios = true,
    sortDate,
    subAccountantOptions,
    hideStatus = false,
    showForceProcess: showForceProcessOption = false,
    onDuplicate = null,
    sortCodeIdOptions = []
}) => {
    const setLoading = typeof setLoadingProp === 'function' ? setLoadingProp : () => {};

    // Not every host of this modal passes a multi-field setter, so fall back to
    // applying the patch one field at a time through the single-field setter.
    const singleFieldSetterRef = useRef(handleAddEditableItemChange);
    singleFieldSetterRef.current = handleAddEditableItemChange;
    const patchAddEditableItem = useCallback((patch) => {
        if (typeof patchAddEditableItemProp === 'function') {
            patchAddEditableItemProp(patch);
            return;
        }
        Object.entries(patch || {}).forEach(([key, value]) => {
            singleFieldSetterRef.current?.(key, value);
        });
    }, [patchAddEditableItemProp]);

    const { userTypeContext, permissionsState } = useContext(PermissionsContext);
    const isClientUser = userTypeContext?.toString() === Constants.UserType.Client;
    const canProcessStatus = canProcessDocumentStatus(userTypeContext, permissionsState, hideStatus);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);

    // Chat functionality
    const { handleSendMessageToChat, selectUserAndOpenChat } = useHamburgerMenu();

    const nodeRef = useRef(null);
    const EDIT_MODAL_SIZE_KEY = 'paymentAcceptanceEditModalSizeMode';
    const EDIT_MODAL_FREE_SIZE_KEY = 'paymentAcceptanceEditModalFreeSize';
    const [modalSizeMode, setModalSizeMode] = useState(() => {
        try {
            const saved = localStorage.getItem(EDIT_MODAL_SIZE_KEY);
            if (saved === 'compact' || saved === 'medium' || saved === 'expanded' || saved === 'free') return saved;
        } catch (_) { /* ignore */ }
        return 'expanded';
    });
    const [sizeBeforeExpand, setSizeBeforeExpand] = useState('medium');
    const [freeSize, setFreeSize] = useState(() => {
        try {
            const raw = localStorage.getItem(EDIT_MODAL_FREE_SIZE_KEY);
            if (raw) {
                const parsed = JSON.parse(raw);
                if (parsed?.width && parsed?.height) return parsed;
            }
        } catch (_) { /* ignore */ }
        return {
            width: Math.round(window.innerWidth * 0.9),
            height: Math.round(window.innerHeight * 0.9),
            top: Math.round(window.innerHeight * 0.05),
            left: Math.round(window.innerWidth * 0.05),
        };
    });
    const resizeStateRef = useRef(null);

    const persistFreeSize = useCallback((next) => {
        setFreeSize(next);
        try {
            localStorage.setItem(EDIT_MODAL_FREE_SIZE_KEY, JSON.stringify(next));
        } catch (_) { /* ignore */ }
    }, []);

    const captureCurrentAsFreeSize = useCallback(() => {
        const el = nodeRef.current;
        if (!el) return freeSize;
        const rect = el.getBoundingClientRect();
        return {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            top: Math.round(rect.top),
            left: Math.round(rect.left),
        };
    }, [freeSize]);

    const applyModalSizeMode = useCallback((mode) => {
        if (mode === 'free') {
            const next = captureCurrentAsFreeSize();
            persistFreeSize(next);
            if (nodeRef.current) nodeRef.current.style.transform = '';
            setModalSizeMode('free');
            try {
                localStorage.setItem(EDIT_MODAL_SIZE_KEY, 'free');
            } catch (_) { /* ignore */ }
            return;
        }
        setModalSizeMode(mode);
        try {
            localStorage.setItem(EDIT_MODAL_SIZE_KEY, mode);
        } catch (_) { /* ignore */ }
        if (nodeRef.current) {
            nodeRef.current.style.transform = '';
        }
    }, [captureCurrentAsFreeSize, persistFreeSize]);

    const handleToggleExpandCollapse = useCallback(() => {
        if (modalSizeMode === 'expanded') {
            applyModalSizeMode(sizeBeforeExpand === 'expanded' ? 'medium' : sizeBeforeExpand);
        } else {
            setSizeBeforeExpand(modalSizeMode);
            applyModalSizeMode('expanded');
        }
    }, [modalSizeMode, sizeBeforeExpand, applyModalSizeMode]);

    const beginResize = useCallback((edge) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        const current = modalSizeMode === 'free' ? freeSize : captureCurrentAsFreeSize();
        if (modalSizeMode !== 'free') {
            persistFreeSize(current);
            setModalSizeMode('free');
            try {
                localStorage.setItem(EDIT_MODAL_SIZE_KEY, 'free');
            } catch (_) { /* ignore */ }
            if (nodeRef.current) nodeRef.current.style.transform = '';
        }
        resizeStateRef.current = {
            edge,
            startX: event.clientX,
            startY: event.clientY,
            start: current,
        };

        const onMove = (ev) => {
            const st = resizeStateRef.current;
            if (!st) return;
            const dx = ev.clientX - st.startX;
            const dy = ev.clientY - st.startY;
            let { width, height, top, left } = st.start;
            if (st.edge.includes('e')) width = st.start.width + dx;
            if (st.edge.includes('s')) height = st.start.height + dy;
            if (st.edge.includes('w')) {
                width = st.start.width - dx;
                left = st.start.left + dx;
            }
            const minW = 560;
            const minH = 420;
            width = Math.max(minW, Math.min(window.innerWidth - 8, width));
            height = Math.max(minH, Math.min(window.innerHeight - 8, height));
            left = Math.max(0, Math.min(window.innerWidth - minW, left));
            top = Math.max(0, Math.min(window.innerHeight - minH, top));
            setFreeSize({ width: Math.round(width), height: Math.round(height), top: Math.round(top), left: Math.round(left) });
        };

        const onUp = () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            resizeStateRef.current = null;
            const rect = nodeRef.current?.getBoundingClientRect();
            if (rect) {
                persistFreeSize({
                    width: Math.round(rect.width),
                    height: Math.round(rect.height),
                    top: Math.round(rect.top),
                    left: Math.round(rect.left),
                });
            }
        };

        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    }, [modalSizeMode, freeSize, captureCurrentAsFreeSize, persistFreeSize]);

    const [container] = useState(() => document.createElement('div'));
    const [FCRate, setFCRate] = useState(1);
    const [isLoadingFCRate, setIsLoadingFCRate] = useState(false);
    const MANUAL_RATE_DECIMALS = 10;
    const [manualRateInput, setManualRateInput] = useState(addEditableItem?.exchangeRate ? String(Number(addEditableItem.exchangeRate)) : '');
    const lastManualRateRef = useRef(null);
    const rateEditSnapshotRef = useRef(null);

    // Defensive Manual-rate detection. The persisted document might come back from
    // the API with exchangeRateType as a number, a numeric string ("1"), or even
    // missing entirely while still carrying a saved exchangeRate. In all of those
    // cases the document was saved with a manual rate, so we MUST treat it as Manual
    // and skip fetching the representative rate (which would overwrite the saved FX
    // amounts on every row).
    const rawExchangeRateType = addEditableItem?.exchangeRateType;
    const hasSavedManualRate =
        addEditableItem?.exchangeRate !== null &&
        addEditableItem?.exchangeRate !== undefined &&
        addEditableItem?.exchangeRate !== '';
    const isManualRate =
        rawExchangeRateType === Constants.ExchangeRateType?.Manual ||
        Number(rawExchangeRateType) === Constants.ExchangeRateType?.Manual ||
        hasSavedManualRate;
    const exchangeRateType = isManualRate
        ? (Constants.ExchangeRateType?.Manual ?? 1)
        : (rawExchangeRateType ?? Constants.ExchangeRateType?.Representative ?? 0);

    // Normalize exchangeRateType on the loaded document so all `=== Manual` comparisons
    // throughout this modal (and child handlers like computeManualRateFromRow) behave
    // consistently. Handles two real-world cases:
    //  1) API returns "1" (string) instead of 1 (number)
    //  2) Document was saved with a manual rate but exchangeRateType came back null/missing
    //     -> infer Manual from the presence of exchangeRate so the modal still treats it
    //        as Manual and does not fetch the representative rate over the saved value.
    useEffect(() => {
        const rt = addEditableItem?.exchangeRateType;
        const hasRate =
            addEditableItem?.exchangeRate !== null &&
            addEditableItem?.exchangeRate !== undefined &&
            addEditableItem?.exchangeRate !== '';

        if (rt != null && rt !== '' && typeof rt !== 'number') {
            const num = Number(rt);
            if (!Number.isNaN(num)) {
                patchAddEditableItem({ exchangeRateType: num });
                return;
            }
        }

        if ((rt == null || rt === '') && hasRate) {
            patchAddEditableItem({
                exchangeRateType: Constants.ExchangeRateType?.Manual ?? 1,
            });
        }
    }, [addEditableItem?.id, addEditableItem?.exchangeRateType, addEditableItem?.exchangeRate, patchAddEditableItem]);
    const [currencyError, setCurrencyError] = useState(false);
    const [dateError, setDateError] = useState(false);
    const [currencyWarn, setCurrencyWarn] = useState(false);
    const [loadingCurrencyRateFor, setLoadingCurrencyRateFor] = useState({});
    // Show/hide PDF iFrame
    const [showPdfIframe, setShowPdfIframe] = useState(true);

    // For the “Add Account Card” modal
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] = useState(false);
    const [newAccountCard, setNewAccountCard] = useState({
        accountCodeName: '',
        accountCodeId: '',
        accountCaseId: '',
    });
    const [addAccountCardType, setAddAccountCardType] = useState('main');
    const [searchTerm, setSearchTerm] = useState('');
    const [cardIdOption, setCardIdOption] = useState(-1);
    const [addCardContext, setAddCardContext] = useState(null);
    const [subAccountantNewOptions, setSubAccountantNewOptions] = useState([]);
    const [forceProcess, setForceProcess] = useState(false);
    
    // Duplicate modal state
    const [dupOpen, setDupOpen] = useState(false);
    const openDuplicate = () => setDupOpen(true);
    const closeDuplicate = () => setDupOpen(false);

    // Linked-invoice (Accounts Receivable) state — populated only when the
    // selected account card has PaymentTerms configured.
    const [outstandingInvoices, setOutstandingInvoices] = useState([]);
    const [isLoadingOutstandingInvoices, setIsLoadingOutstandingInvoices] = useState(false);

    // The account card object picked in this receipt (if any). Used to detect PaymentTerms.
    const selectedAccountCardForLink = useMemo(() => {
        if (!addEditableItem?.accountCodeId || !accountCardOptions) return null;
        return accountCardOptions.find(
            (c) => String(c.cardId) === String(addEditableItem.accountCodeId)
        ) || null;
    }, [addEditableItem?.accountCodeId, accountCardOptions]);

    const cardHasPaymentTerms = useMemo(() => {
        const v = selectedAccountCardForLink?.paymentTermsType ?? selectedAccountCardForLink?.PaymentTermsType;
        return v !== null && v !== undefined && v !== '';
    }, [selectedAccountCardForLink]);

    useEffect(() => {
        // Fetch outstanding invoices whenever the chosen card changes,
        // but only when the card actually has PaymentTerms.
        let cancelled = false;
        const run = async () => {
            if (!cardHasPaymentTerms || !client?.caseId || !addEditableItem?.accountCodeId) {
                setOutstandingInvoices([]);
                return;
            }
            try {
                setIsLoadingOutstandingInvoices(true);
                const res = await ReceivablesService.GetOutstandingInvoicesForCard(
                    client.caseId,
                    addEditableItem.accountCodeId,
                    token
                );
                if (!res.ok) {
                    if (!cancelled) setOutstandingInvoices([]);
                    return;
                }
                const data = await res.json();
                if (!cancelled) setOutstandingInvoices(Array.isArray(data) ? data : []);
            } catch (_) {
                if (!cancelled) setOutstandingInvoices([]);
            } finally {
                if (!cancelled) setIsLoadingOutstandingInvoices(false);
            }
        };
        run();
        return () => { cancelled = true; };
    }, [cardHasPaymentTerms, client?.caseId, addEditableItem?.accountCodeId, token]);

    const linkedInvoiceValue = useMemo(() => {
        if (!cardHasPaymentTerms) return null;
        if (addEditableItem?.relatedIncomeId) {
            const match = outstandingInvoices.find(o => o.id === addEditableItem.relatedIncomeId);
            if (match) return match;
        }
        if (addEditableItem?.relatedInvoiceReference) {
            return { id: null, reference: addEditableItem.relatedInvoiceReference, freeSolo: true };
        }
        return null;
    }, [cardHasPaymentTerms, addEditableItem?.relatedIncomeId, addEditableItem?.relatedInvoiceReference, outstandingInvoices]);

    const fetchSubAccountants = async () => {
        if (!client?.accountantId) {
            return;
        }
        const result2 = await SubAccountantService.GetSubAccountantByAccountantId(token, client?.accountantId);
        const accountantResult = await SubAccountantService.GetAccountantById(token, client?.accountantId);
        const enhancedAccountantResult = {
            ...accountantResult,
            subAccountantId: accountantResult.accountantId, // Add subAccountantId as same as accountantId
        };

        if (result2) {
            const combinedSubAccountants = [enhancedAccountantResult, ...result2];

            // If client exists, add it to the combined list
            if (client) {
                combinedSubAccountants.push({
                    subAccountantId: client.caseId,
                    name: client.name,
                });
            }

            const combinedOptions = combinedSubAccountants.map((acc) => ({
                value: acc.subAccountantId,
                label: acc.name,
            }));

            setSubAccountantNewOptions(combinedOptions);
        } else {
            toast.error(t('fetchSubAccountantsDataError'));
        }
    };

    // Flatten all relevant doc URLs, ignoring null/empty strings.
    const allDocUrls = React.useMemo(() => {
        const docArray = [];
        // push only if not null/undefined/empty
        if (addEditableItem?.receiptDocumentUrl) {
            docArray.push(addEditableItem.receiptDocumentUrl);
        }

        // For each check
        addEditableItem?.checks?.forEach((check) => {
            if (check.documentUrl) {
                docArray.push(check.documentUrl);
            }
        });

        addEditableItem?.creditCards?.forEach((creditCard) => {
            if (creditCard.documentUrl) {
                docArray.push(creditCard.documentUrl);
            }
        });

        addEditableItem?.cash?.forEach((cash) => {
            if (cash.documentUrl) {
                docArray.push(cash.documentUrl);
            }
        });

        addEditableItem?.bankTransactions?.forEach((bankTransaction) => {
            if (bankTransaction.documentUrl) {
                docArray.push(bankTransaction.documentUrl);
            }
        });

        return docArray;
    }, [addEditableItem]);



    const combinedItems = React.useMemo(() => {
        const checks = (addEditableItem?.checks || []).map((chk, idx) => ({ ...chk, itemType: 'checks', itemTypeIndex: idx }));
        const ccs = (addEditableItem?.creditCards || []).map((cc, idx) => ({ ...cc, itemType: 'creditCards', itemTypeIndex: idx }));
        const csh = (addEditableItem?.cash || []).map((c, idx) => ({ ...c, itemType: 'cash', itemTypeIndex: idx }));
        const bts = (addEditableItem?.bankTransactions || []).map((bt, idx) => ({ ...bt, itemType: 'bankTransactions', itemTypeIndex: idx }));
        const ofs = (addEditableItem?.offsets || []).map((of, idx) => ({ ...of, itemType: 'offsets', itemTypeIndex: idx }));
        return [...checks, ...ccs, ...csh, ...bts, ...ofs];
    }, [addEditableItem]);

    const [grossOverride, setGrossOverride] = useState(null);

    /* Reset a typed comparison gross when switching to another document / draft. */
    useEffect(() => {
        setGrossOverride(null);
    }, [addEditableItem?.id, addEditableItem?.uploadNumber]);

    /* A typed gross here is only for comparison. As soon as the real inputs change
       (payment lines or withholding), go back to the live derived gross. */
    useEffect(() => {
        setGrossOverride(null);
    }, [combinedItems, addEditableItem?.withholdingTax]);

    /* Gross − withholding = net. The saved amount of a receipt/payment is the payment lines
       total, so here the gross follows the lines and the deduction as they are edited unless
       the user types a comparison gross to inspect the difference. */
    const amounts = useMemo(
        () => computePaymentAmounts({
            amount: addEditableItem?.amount,
            withholdingTax: addEditableItem?.withholdingTax,
            items: combinedItems,
            deriveGrossFromLines: true,
            grossOverride,
        }),
        [addEditableItem?.amount, addEditableItem?.withholdingTax, combinedItems, grossOverride]
    );

    /* ── OCR field boxes on the matching carousel document ── */
    const fieldPositions = useFieldPositions({
        caseId: client?.caseId,
        entityType: 'PaymentAcceptance',
        documentId: itemEditing ? addEditableItem?.id : null,
        token,
        enabled: showPdfIframe,
        refreshKey: allDocUrls.map((u) => u.split('?')[0]).join('|'),
    });
    const [activeOcrField, setActiveOcrField] = useState(null);
    useEffect(() => setActiveOcrField(null), [addEditableItem?.id]);
    const [fieldBoxesShown, setFieldBoxesShown] = useState(false);

    // Same rule as the server: line fields only for exactly one check / bank-transfer line.
    const singleBankLine = useMemo(() => {
        const checks = addEditableItem?.checks || [];
        const banks = addEditableItem?.bankTransactions || [];
        const others = (addEditableItem?.creditCards?.length || 0) + (addEditableItem?.cash?.length || 0);
        if (others > 0 || checks.length + banks.length !== 1) return null;
        return checks[0] || banks[0];
    }, [addEditableItem]);

    // Only values the item actually carries take part; a box disappears as soon as its field is edited.
    const fieldBoxValues = useMemo(() => {
        if (!addEditableItem) return {};
        const values = {};
        const add = (field, raw, toCanonical) => {
            if (raw !== undefined) values[field] = toCanonical(raw);
        };
        add('reference', addEditableItem.reference, canonical.text);
        add('confirmationNumber', addEditableItem.confirmationNumber, canonical.digits);
        add('amount', grossOverride != null ? grossOverride : addEditableItem.amount, canonical.number);
        add('date', addEditableItem.date, canonical.date);
        add('withholdingTax', addEditableItem.withholdingTax, canonical.number);
        add('accountCodeName', addEditableItem.accountCodeName, canonical.text);
        add('accountCaseId', addEditableItem.accountCaseId, canonical.digits);
        if (singleBankLine) {
            add('line.bankCode', singleBankLine.bankCode, canonical.digits);
            add('line.bankBranchCode', singleBankLine.bankBranchCode, canonical.digits);
            add('line.supplierAccountNumber', singleBankLine.supplierAccountNumber, canonical.digits);
        }
        return values;
    }, [addEditableItem, grossOverride, singleBankLine]);
    const visibleFieldBoxes = useMemo(
        () => visibleFieldSet(fieldPositions, fieldBoxValues),
        [fieldPositions, fieldBoxValues]
    );
    const fieldBoxLabels = useMemo(() => ({
        accountCodeName: addEditableItem?.paymentAcceptanceType === 'תקבול' ? t('Client Name') : t('Provider Name'),
        accountCaseId: t('CompanyId'),
        reference: t('Reference'),
        date: t('ReceiptPaymentDate'),
        amount: t('TotalGross'),
        withholdingTax: t('WithholdingAtSource'),
        confirmationNumber: t('ConfirmationNumber'),
        'line.reference2': t('CheckNumber'),
        'line.bankCode': t('BankCode'),
        'line.bankBranchCode': t('BankBranchCode'),
        'line.supplierAccountNumber': t('SupplierAccountNumber'),
    }), [t, addEditableItem?.paymentAcceptanceType]);
    const fieldBoxOrder = useMemo(() => Object.keys(fieldBoxLabels), [fieldBoxLabels]);

    const handleOcrFieldFocus = useCallback((event) => {
        const row = event.target?.closest?.('[data-ocr-field]');
        setActiveOcrField(row ? row.getAttribute('data-ocr-field') : null);
    }, []);
    const handleOcrFieldBlur = useCallback((event) => {
        const from = event.target?.closest?.('[data-ocr-field]');
        if (from && !from.contains(event.relatedTarget)) setActiveOcrField(null);
    }, []);
    const handleFieldBoxClick = useCallback((field) => {
        const row = nodeRef.current?.querySelector(`[data-ocr-field="${field}"]`);
        setActiveOcrField(field);
        if (!row) return;
        row.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
        const input = row.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
        input?.focus();
    }, []);

    // Adding a line pre-fills the net that is still unallocated so one line closes the document.
    // Debit/credit follow OCR (SinglePaymentAcceptanceWorker): party card + method system card.
    const handleAddItemWithSuggestedAmount = useCallback(
        (theType) => {
            const accounts = getPaymentAcceptanceLineAccounts({
                paymentType: addEditableItem?.paymentAcceptanceType,
                itemType: theType,
                partyAccountId: addEditableItem?.accountCodeId,
                systemAccounts: caseSystemSettings,
            });
            const bankDetails = isBankPaymentType(theType)
                ? getCardBankDetails(selectedAccountCardForLink)
                : null;
            handleAddItem(theType, amounts.suggestedLineAmount, { ...accounts, ...bankDetails });
        },
        [
            handleAddItem,
            amounts.suggestedLineAmount,
            addEditableItem?.paymentAcceptanceType,
            addEditableItem?.accountCodeId,
            caseSystemSettings,
            selectedAccountCardForLink,
        ]
    );

    const handleFillBankRowsFromCard = useCallback(
        (targets, details) => {
            targets.forEach(({ itemType, itemTypeIndex }) => {
                Object.entries(details).forEach(([field, value]) => {
                    handleItemChange(itemType, itemTypeIndex, field, value);
                });
            });
        },
        [handleItemChange]
    );

    const handleCardBankDetailsSaved = useCallback(
        (updatedCard) => {
            if (typeof setAccountCardOptions !== 'function') return;
            setAccountCardOptions((prev) =>
                (prev || []).map((option) =>
                    String(option.cardId) === String(updatedCard.cardId) ? updatedCard : option
                )
            );
        },
        [setAccountCardOptions]
    );

    // Delete only the payment-method row. If the PDF lived only on that row's
    // documentUrl (common after OCR create), promote it to receiptDocumentUrl
    // first so the iframe preview is not cleared.
    const handleRemovePaymentLine = useCallback(
        (itemType, itemTypeIndex) => {
            const items = addEditableItem?.[itemType] || [];
            const removed = items[itemTypeIndex];
            const removedUrl = removed?.documentUrl;

            if (removedUrl) {
                const lineTypes = ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'];
                const stillOnOtherLine = lineTypes.some((t) =>
                    (addEditableItem?.[t] || []).some(
                        (r, i) =>
                            !(t === itemType && i === itemTypeIndex) &&
                            r?.documentUrl === removedUrl
                    )
                );
                const alreadyOnReceipt = addEditableItem?.receiptDocumentUrl === removedUrl;
                if (!stillOnOtherLine && !alreadyOnReceipt && !addEditableItem?.receiptDocumentUrl) {
                    handleAddEditableItemChange('receiptDocumentUrl', removedUrl);
                }
            }

            handleRemoveItem(itemType, itemTypeIndex);
        },
        [addEditableItem, handleAddEditableItemChange, handleRemoveItem]
    );

    //------------------------------------------------------------------------------------------

    // Pre-fetch the representative rate whenever currency code or main date changes (Representative mode only).
    // Mirrors EditModal.js FCRate logic so typing in foreignCurrencyAmount is instant (no per-keystroke API call).
    useEffect(() => {
        async function fetchRepresentativeRate() {
            setIsLoadingFCRate(true);
            try {
                const rate = await ForeignCurrencyService.GetIlsRateForDate(
                    addEditableItem.foreignCurrencyCode,
                    addEditableItem.date,
                    token
                );
                setFCRate(rate);
            } catch (err) {
                console.error('Failed to fetch representative rate', err);
                toast.error(t('CurrencyRateFetchError'));
            } finally {
                setIsLoadingFCRate(false);
            }
        }

        if (
            addEditableItem.foreignCurrencyCode != null &&
            addEditableItem.foreignCurrencyCode !== '' &&
            addEditableItem.date &&
            !isManualRate
        ) {
            fetchRepresentativeRate();
        } else {
            if (addEditableItem.foreignCurrencyCode == null || addEditableItem.foreignCurrencyCode === '') {
                setFCRate(1);
            }
            setIsLoadingFCRate(false);
        }
    }, [addEditableItem.foreignCurrencyCode, addEditableItem.date, isManualRate]);

    // 1. Core helper: given an idx, date and amount, fetch the rate (or use manual) and write back the calculated amount
    const recalcAmount = async (itemType, idx, paymentDate, foreignCurrencyAmount, code = null) => {
        if (
            addEditableItem.foreignCurrencyCode == null ||
            foreignCurrencyAmount == null || foreignCurrencyAmount === ''
        ) {
            return;
        }
        const fcNum = Number(foreignCurrencyAmount);
        if (isNaN(fcNum) || fcNum <= 0) return;
        if (isManualRate) {
            const manualRate = Number(addEditableItem?.exchangeRate ?? manualRateInput);
            if (manualRate > 0 && !isNaN(manualRate)) {
                const amount = Number((fcNum * manualRate).toFixed(2));
                handleItemChange(itemType, idx, 'amount', amount);
            }
            return;
        }
        // Representative mode requires a paymentDate to fetch the API rate
        if (!paymentDate) return;
        const loadingKey = `${itemType}-${idx}`;
        setLoadingCurrencyRateFor((prev) => ({ ...prev, [loadingKey]: true }));
        try {
            const rate = await ForeignCurrencyService.GetIlsRateForDate(
                code != null ? code : addEditableItem.foreignCurrencyCode,
                paymentDate,
                token
            );
            const amount = Number((fcNum * rate).toFixed(2));
            handleItemChange(itemType, idx, 'amount', amount);
        } catch (err) {
            console.error('Failed to recalc FC amount', err);
            toast.error(t('CurrencyRateFetchError'));
        } finally {
            setLoadingCurrencyRateFor((prev) => {
                const next = { ...prev };
                delete next[loadingKey];
                return next;
            });
        }
    };

    const debouncedRecalc = useRef(
        debounce((itemType, idx, paymentDate, foreignCurrencyAmount) => {
            recalcAmount(itemType, idx, paymentDate, foreignCurrencyAmount)
        }, 500)
    ).current

    // Ref mirror of addEditableItem so debounced callbacks read the latest values
    // (props captured in the closure at scheduling time would be stale by the time the timer fires).
    const addEditableItemRef = useRef(addEditableItem);
    useEffect(() => { addEditableItemRef.current = addEditableItem; }, [addEditableItem]);

    // Shared debounce for "derive the manual rate from a row's amount + FC".
    // Resets on every keystroke in any amount/FC field of any row, so the rate is only
    // computed once the user pauses typing - otherwise partial typed values would write
    // wrong intermediate rates and that wrong rate would then overwrite the amount the
    // user is in the middle of typing.
    const rateCalcTimeoutRef = useRef(null);
    const RATE_CALC_DEBOUNCE_MS = 600;

    useEffect(() => {
        return () => {
            if (rateCalcTimeoutRef.current) clearTimeout(rateCalcTimeoutRef.current);
        };
    }, []);

    const computeManualRateFromRow = (itemType, idx) => {
        const latest = addEditableItemRef.current;
        if (!latest) return;
        const latestType = latest.exchangeRateType ?? Constants.ExchangeRateType?.Representative ?? 0;
        if (latestType !== (Constants.ExchangeRateType?.Manual ?? 1)) return;
        if (latest.foreignCurrencyCode == null || latest.foreignCurrencyCode === '') return;

        const item = latest[itemType]?.[idx];
        if (!item) return;
        const amountNum = Number(item.amount);
        const fcNum = Number(item.foreignCurrencyAmount);
        if (isNaN(amountNum) || amountNum <= 0 || isNaN(fcNum) || fcNum <= 0) return;

        const newRate = (amountNum / fcNum).toFixed(MANUAL_RATE_DECIMALS);
        setManualRateInput(newRate);
        lastManualRateRef.current = newRate;
        handleAddEditableItemChange('exchangeRate', Number(newRate));
    };

    // Schedules the shared rate-calc debounce, keyed implicitly by "the most recently
    // edited row" - the last call to scheduleRateCalcForRow wins.
    const scheduleRateCalcForRow = (itemType, idx) => {
        if (rateCalcTimeoutRef.current) clearTimeout(rateCalcTimeoutRef.current);
        rateCalcTimeoutRef.current = setTimeout(() => {
            rateCalcTimeoutRef.current = null;
            computeManualRateFromRow(itemType, idx);
        }, RATE_CALC_DEBOUNCE_MS);
    };

    const handleForeignAmountChange = (itemType, idx, newForeignAmount) => {
        // Allow clearing to null regardless of currency selection
        if (newForeignAmount === '') {
            handleItemChange(itemType, idx, 'foreignCurrencyAmount', null);
            return;
        }
        if (
            addEditableItem.foreignCurrencyCode === null ||
            addEditableItem.foreignCurrencyCode === '' ||
            addEditableItem.foreignCurrencyCode === undefined
        ) {
            toast.info(t('ToCalculateAmountWithForeignCurrencyChooseDateAndCurrencyCode'));
            return;
        }
        // 1) immediately update the model
        handleItemChange(itemType, idx, 'foreignCurrencyAmount', newForeignAmount)

        // 2) Recalculate using whichever rate mode applies
        if (isManualRate) {
            const fcNum = Number(newForeignAmount);
            if (isNaN(fcNum) || fcNum <= 0) return;

            // Always reset the shared rate-calc debounce so a wrong rate is never
            // written from partial typed values.
            scheduleRateCalcForRow(itemType, idx);

            const amountNum = Number(addEditableItem[itemType]?.[idx]?.amount);
            const amountSet = !isNaN(amountNum) && amountNum > 0;
            // Both amounts set -> rate gets recalculated by the shared debounce; do NOT
            // overwrite the amount the user just typed.
            if (amountSet) return;

            // Flow 2: amount empty + rate is set -> derive amount = FC * rate.
            const rateNum = Number(manualRateInput);
            const hasValidRate = manualRateInput !== '' && !isNaN(rateNum) && rateNum > 0;
            if (hasValidRate) {
                handleItemChange(itemType, idx, 'amount', Number((fcNum * rateNum).toFixed(2)));
            }
        } else {
            // Representative mode: use the pre-fetched FCRate for instant calculation.
            // If the row has its own paymentDate that differs from the main date, fall back to the per-row API call.
            const item = addEditableItem[itemType]?.[idx];
            const rowDate = item?.paymentDate;
            const mainDate = addEditableItem?.date;
            const rowDateDiffersFromMain = rowDate && mainDate &&
                new Date(rowDate).toDateString() !== new Date(mainDate).toDateString();

            if (FCRate > 0 && !isNaN(FCRate) && !rowDateDiffersFromMain) {
                // Instant calculation using the pre-fetched rate
                const amount = Number((Number(newForeignAmount) * FCRate).toFixed(2));
                handleItemChange(itemType, idx, 'amount', amount);
            } else {
                // Row has a different paymentDate — fetch its own rate
                const dateToUse = rowDate || mainDate;
                debouncedRecalc(itemType, idx, dateToUse, newForeignAmount);
            }
        }
    }


    // 3. When the user changes the payment date
    const handlePaymentDateChange = (itemType, idx, newDate) => {
        if (!newDate) {
            return;
        }
        handleItemChange(itemType, idx, 'paymentDate', newDate);
        const foreignCurrencyAmount =
            addEditableItem[itemType]?.[idx]?.foreignCurrencyAmount;
        recalcAmount(itemType, idx, newDate, foreignCurrencyAmount);
    };

    // 4. When the overall currency code changes, re‑run for every item
    const handleCurrencyCodeChange = async (newCode) => {
        handleAddEditableItemChange('foreignCurrencyCode', newCode);
        if (newCode === null || newCode === '' || newCode === undefined) {
            handleAddEditableItemChange('exchangeRate', null);
            handleAddEditableItemChange('exchangeRateType', Constants.ExchangeRateType?.Representative ?? 0);
            setManualRateInput('');
            lastManualRateRef.current = null;
            ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'].forEach(type => {
                (addEditableItem[type] || []).forEach((item, idx) => {
                    handleItemChange(type, idx, 'amount', null);
                    handleItemChange(type, idx, 'foreignCurrencyAmount', null);
                });
            });
            return;
        }
        const itemTypes = ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'];
        const manualRate = isManualRate ? Number(addEditableItem?.exchangeRate ?? manualRateInput) : null;
        const useManualRate = isManualRate && manualRate > 0 && !isNaN(manualRate);
        for (const type of itemTypes) {
            const items = addEditableItem[type] || [];
            for (let idx = 0; idx < items.length; idx++) {
                const item = items[idx];
                const amountRaw = item?.amount;
                if (amountRaw == null || amountRaw === '') continue;
                const amountNum = Number(amountRaw);
                if (isNaN(amountNum)) continue;
                const amountFixed = Number(amountNum.toFixed(2));
                handleItemChange(type, idx, 'amount', amountFixed);
                const foreignEmpty =
                    item?.foreignCurrencyAmount == null || item?.foreignCurrencyAmount === '';
                const dateToUse = item?.paymentDate || addEditableItem?.date;
                if (foreignEmpty && dateToUse && newCode != null) {
                    if (useManualRate) {
                        handleItemChange(type, idx, 'foreignCurrencyAmount', (amountNum / manualRate).toFixed(2));
                    } else if (!isManualRate) {
                        const loadingKey = `${type}-${idx}`;
                        setLoadingCurrencyRateFor((prev) => ({ ...prev, [loadingKey]: true }));
                        try {
                            const rate = await ForeignCurrencyService.GetIlsRateForDate(newCode, dateToUse, token);
                            if (rate != null && rate > 0) {
                                handleItemChange(type, idx, 'foreignCurrencyAmount', (amountNum / rate).toFixed(2));
                            }
                        } catch (err) {
                            console.error('Failed to fetch rate for foreign amount', err);
                            toast.error(t('CurrencyRateFetchError'));
                        } finally {
                            setLoadingCurrencyRateFor((prev) => {
                                const next = { ...prev };
                                delete next[loadingKey];
                                return next;
                            });
                        }
                    }
                }
            }
        }
        itemTypes.forEach(type => {
            (addEditableItem[type] || []).forEach((item, idx) => {
                recalcAmount(type, idx, item.paymentDate, item.foreignCurrencyAmount, newCode);
            });
        });
    };

    const handleManualRateChange = useCallback((value) => {
        const num = value === '' || value == null ? null : (Number(value) || null);
        handleAddEditableItemChange('exchangeRate', num);
        const itemTypes = ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'];
        if (num > 0) {
            lastManualRateRef.current = value;
            itemTypes.forEach(type => {
                (addEditableItem[type] || []).forEach((item, idx) => {
                    const key = `${type}-${idx}`;
                    const snap = rateEditSnapshotRef.current?.[key];
                    const origAmount = snap ? Number(snap.amount) : null;
                    const origFc = snap ? Number(snap.fc) : null;
                    const hadOrigAmount = origAmount != null && !isNaN(origAmount) && origAmount > 0;
                    const hadOrigFc = origFc != null && !isNaN(origFc) && origFc > 0;
                    if (hadOrigAmount) {
                        handleItemChange(type, idx, 'foreignCurrencyAmount', Number((origAmount / num).toFixed(2)));
                    } else if (hadOrigFc) {
                        handleItemChange(type, idx, 'amount', Number((origFc * num).toFixed(2)));
                    }
                });
            });
        } else {
            itemTypes.forEach(type => {
                (addEditableItem[type] || []).forEach((item, idx) => {
                    handleItemChange(type, idx, 'foreignCurrencyAmount', null);
                });
            });
        }
    }, [addEditableItem, handleAddEditableItemChange, handleItemChange]);

    const calculatedManualRateFromTable = useMemo(() => {
        const first = combinedItems.find(
            (r) => r.amount != null && r.amount !== '' && r.foreignCurrencyAmount != null && r.foreignCurrencyAmount !== ''
        );
        if (!first) return null;
        const a = Number(first.amount);
        const fc = Number(first.foreignCurrencyAmount);
        if (a <= 0 || fc <= 0 || isNaN(a) || isNaN(fc)) return null;
        return (a / fc).toFixed(MANUAL_RATE_DECIMALS);
    }, [combinedItems]);

    const manualRateDisplayValue = useMemo(() => {
        if (manualRateInput !== '' && manualRateInput != null) return manualRateInput;
        return calculatedManualRateFromTable ?? '';
    }, [manualRateInput, calculatedManualRateFromTable]);

    const hasValidDisplayRate = useMemo(
        () => manualRateDisplayValue !== '' && !isNaN(Number(manualRateDisplayValue)) && Number(manualRateDisplayValue) > 0,
        [manualRateDisplayValue]
    );

    //------------------------------------------------------------------------------------------




    // --- REVERSE CALCULATION: amount -> foreignCurrencyAmount ---
    const debouncedRecalcReverse = useMemo(() =>
        debounce(async (itemType, idx, amount, paymentDate, codeOverride) => {
            if (amount === '' || isNaN(Number(amount))) return;
            const code = codeOverride ?? addEditableItem.foreignCurrencyCode;
            if (code === null || code === '' || code === undefined) return;
            const amountNum = Number(amount);
            const manualRate = isManualRate ? Number(addEditableItem?.exchangeRate ?? manualRateInput) : null;
            if (isManualRate) {
                if (manualRate > 0 && !isNaN(manualRate)) {
                    const foreignAmt = Number((amountNum / manualRate).toFixed(2));
                    handleItemChange(itemType, idx, 'foreignCurrencyAmount', foreignAmt);
                }
                return;
            }
            // Representative mode: need paymentDate to fetch rate
            if (!paymentDate) return;
            const loadingKey = `${itemType}-${idx}`;
            setLoadingCurrencyRateFor((prev) => ({ ...prev, [loadingKey]: true }));
            try {
                const rate = await ForeignCurrencyService.GetIlsRateForDate(code, paymentDate, token);
                const foreignAmt = Number((amountNum / rate).toFixed(2));
                handleItemChange(itemType, idx, 'foreignCurrencyAmount', foreignAmt);
            } catch (err) {
                console.error('Failed to recalc reverse FC amount', err);
                toast.error(t('CurrencyRateFetchError'));
            } finally {
                setLoadingCurrencyRateFor((prev) => {
                    const next = { ...prev };
                    delete next[loadingKey];
                    return next;
                });
            }
        }, 500)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , [addEditableItem.foreignCurrencyCode, addEditableItem?.exchangeRate, isManualRate, manualRateInput, handleItemChange, t]);

    const handleAmountChange = useCallback((itemType, idx, newAmount) => {
        if (newAmount === '') {
            handleItemChange(itemType, idx, 'amount', null);
            if (isManualRate) {
                setManualRateInput('');
                handleAddEditableItemChange('exchangeRate', null);
            }
            return;
        }
        if (
            isManualRate &&
            (addEditableItem.foreignCurrencyCode == null ||
                addEditableItem.foreignCurrencyCode === '' ||
                addEditableItem.foreignCurrencyCode === undefined)
        ) {
            toast.info(t('ToCalculateAmountWithForeignCurrencyChooseDateAndCurrencyCode'));
        }
        handleItemChange(itemType, idx, 'amount', newAmount);

        if (isManualRate) {
            const amountNum = Number(newAmount);
            if (isNaN(amountNum) || amountNum <= 0) return;

            // Always reset the shared rate-calc debounce so a wrong rate is never
            // written from partial typed values.
            scheduleRateCalcForRow(itemType, idx);

            const fcNum = Number(addEditableItem[itemType]?.[idx]?.foreignCurrencyAmount);
            const fcSet = !isNaN(fcNum) && fcNum > 0;
            // Both amounts set -> rate gets recalculated by the shared debounce; do NOT
            // overwrite the FC the user already had.
            if (fcSet) return;

            // Flow 3: FC empty + rate is set -> derive FC = amount / rate.
            const rateNum = Number(manualRateInput);
            const hasValidRate = manualRateInput !== '' && !isNaN(rateNum) && rateNum > 0;
            if (hasValidRate) {
                handleItemChange(itemType, idx, 'foreignCurrencyAmount', Number((amountNum / rateNum).toFixed(2)));
            }
        } else {
            const item = addEditableItem[itemType]?.[idx];
            const paymentDate = item?.paymentDate;
            const currencyCode = addEditableItem.foreignCurrencyCode;
            debouncedRecalcReverse(itemType, idx, newAmount, paymentDate, currencyCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addEditableItem, isManualRate, manualRateInput, debouncedRecalcReverse, handleItemChange, t]);

    //------------------------------------------------------------------------------------------

    const renderManualRateInput = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, marginTop: 1 }}>
            <div style={{ fontWeight: 'bold', fontSize: '12px' }}>{t('ManualExchangeRate')}</div>
            <TextField
                className={fieldStyles.styleInput}
                fullWidth
                placeholder={t('ManualExchangeRate')}
                value={manualRateDisplayValue}
                onFocus={() => {
                    if (manualRateInput === '' || manualRateInput == null) {
                        const fromModel = addEditableItem?.exchangeRate;
                        if (fromModel != null && fromModel !== '') {
                            setManualRateInput(String(Number(fromModel)));
                        } else if (calculatedManualRateFromTable) {
                            setManualRateInput(calculatedManualRateFromTable);
                        }
                    }
                    const snapshot = {};
                    ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'].forEach(type => {
                        (addEditableItem[type] || []).forEach((item, idx) => {
                            snapshot[`${type}-${idx}`] = {
                                amount: item?.amount,
                                fc: item?.foreignCurrencyAmount,
                            };
                        });
                    });
                    rateEditSnapshotRef.current = snapshot;
                }}
                onBlur={(e) => {
                    rateEditSnapshotRef.current = null;
                    const val = e.target.value;
                    if (val !== '' && !isNaN(val) && Number(val) > 0) {
                        const formatted = Number(val).toFixed(MANUAL_RATE_DECIMALS);
                        setManualRateInput(formatted);
                        handleManualRateChange(formatted);
                    }
                }}
                onChange={(e) => {
                    const v = e.target.value;
                    setManualRateInput(v);
                    handleManualRateChange(v);
                }}
                variant="standard"
                type="number"
                InputProps={{
                    ...inputPropsStyle,
                    sx: {
                        ...inputPropsStyle?.sx,
                        border: (isManualRate && !hasValidDisplayRate)
                            ? '2px solid #d32f2f'
                            : '1px solid transparent',
                    },
                }}
                inputProps={inputStyle}
                disabled={isDisabledForm}
            />
        </Box>
    );

    // Compute missing fields to help user enable Save
    const missingFields = useMemo(() => {
        const missing = [];
        const isIncome = addEditableItem.paymentAcceptanceType === 'תקבול';
        const clientOrProviderLabel = isIncome ? t('Client Name') : t('Provider Name');
        if (!addEditableItem.accountCodeId) missing.push(clientOrProviderLabel);
        if (!addEditableItem.paymentAcceptanceType) missing.push(t('PaymentType'));
        if (!addEditableItem.date) missing.push(t('ReceiptPaymentDate'));
        if (!addEditableItem.uploadDate) missing.push(t('RegistrationDate'));
        // if (!addEditableItem.description) missing.push(t('ReceiptPaymentDescription'));

        // Validate line items
        combinedItems.forEach((row, idx) => {
            const rowPrefix = `${t('Type')}: ${t(row.itemType)} #${idx + 1}`;
            if (row.amount == null || row.amount === '') missing.push(`${rowPrefix} - ${t('Amount')}`);
            if (!row.debitAccount) missing.push(`${rowPrefix} - ${t('Debit Account')}`);
            if (!row.creditAccount) missing.push(`${rowPrefix} - ${t('Credit Account')}`);
        });
        return missing;
    }, [addEditableItem, combinedItems, t]);

    // Index for the doc being viewed
    const [docIndex, setDocIndex] = useState(0);

    const handleToggleIframe = () => {
        setShowPdfIframe((prev) => !prev);
    };

    // MUI Autocomplete for the main “Client/Provider” field
    const handleMuiChangeProxy = (event, value) => {
        // Clear any item-level context; this is a top-level selection
        setAddCardContext(null);



        if (!value) {
            handleAddEditableItemChange('accountCodeId', null);
            return;
        }
        if (value.value1 === 'AddItem') {
            // open the AddAccountCardModal
            setAddNewAccountCardDocument(true);
            setShowAccountCardInputsEdit(false);
            // create new card with the typed input
            setNewAccountCard({
                accountCodeName: (value.searchTerm || searchTerm || ''),
                accountCodeId: cardIdOption,
                accountCaseId: '',
            });
        } else {
            handleMuiChange(event, value);
        }
    };

    const [deferredReceipt, setDeferredReceipt] = useState(false);


    // If user clicks "No options," we create an artificial option to trigger “AddItem”.
    const handleNoOptionClick = (searchTerm) => {
        if (formattedAccountCardOptions.length > 0) {
            const newVal = {
                ...formattedAccountCardOptions[0],
                value1: 'AddItem',
                searchTerm
            };
            handleMuiChangeProxy(null, newVal);
        }
    };

    // Once a new account is added, we want to select it automatically
    const [newCardId, setNewCardId] = useState(null);
    const handleChangeAfterAdd = async (cardId, type) => {
        // Refresh enums only on successful create/edit callback, not on every modal close.
        if (typeof fetchEnums === 'function') {
            try {
                await fetchEnums(null, token, client);
            } catch (_) {
                // Ignore here; AddAccountCardModal handles user-facing errors.
            }
        }

        // Ensure account card options prop is updated immediately in this modal.
        if (typeof setAccountCardOptions === 'function' && client?.caseId && token) {
            try {
                const cardsRes = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
                if (cardsRes?.ok) {
                    const cardsData = await cardsRes.json();
                    setAccountCardOptions([{ name: t('AddAccountCard'), value1: 'AddItem' }, ...(cardsData || [])]);
                }
            } catch (_) {
                // Ignore fallback sync failure; enums refresh above is primary source.
            }
        }
        setNewCardId({ cardId, type });
    };

    const formattedAccountCardOptions = accountCardOptions?.map((option) => ({
        value: option.cardId,
        label: option.name,
        name: option.name,
        accountCaseId: option.accountCaseId || '',
        cardId: option.cardId,
        value1: option.value1,
        palCode: option.palCode,
        isEditable: option.isEditable,
        externalSoftwareCardNumber: option.externalSoftwareCardNumber || '',
    }));

    const formattedAccountCardOptions2 = accountCardOptions
        ?.map((option) => ({
            value: option.cardId,
            label: option.accountCaseId
                ? `${option.name} - ${option?.accountCaseId || ''}`
                : `${option.name}`,
            name: option.name,
            accountCaseId: option.accountCaseId || '',
            cardId: option.cardId,
            value1: option.value1,
            palCode: option.palCode,
            isEditable: option.isEditable
        }))
        .slice(1); // Removes the first item

    const filterAccountCardOptions = useCallback((options, state) => {
        const input = (state.inputValue || '').trim();
        if (!input) return options;
        const inputLower = input.toLowerCase();
        const filtered = options.filter((opt) => {
            if (opt.value1 === 'AddItem') return false;
            const cardIdStr = String(opt.cardId ?? opt.value ?? '');
            const matchCardId = cardIdStr.toLowerCase().includes(inputLower) || cardIdStr.includes(input);
            const matchLabel = (opt.label || '').toLowerCase().includes(inputLower);
            const matchName = (opt.name || '').toLowerCase().includes(inputLower);
            const matchPalCode = (opt.palCode != null && String(opt.palCode).toLowerCase().includes(inputLower));
            const extId = (opt.externalSoftwareCardNumber || '').trim();
            const matchExternalSoftwareCardId = extId !== '' && extId.toLowerCase().includes(inputLower);
            return matchCardId || matchLabel || matchName || matchPalCode || matchExternalSoftwareCardId;
        });
        if (filtered.length === 0) {
            return [{ value1: 'AddItem', searchTerm: input, cardId: '', name: '', label: '', accountCaseId: '' }];
        }
        return filtered;
    }, []);

    useEffect(() => {
        if (accountCardOptions && accountCardOptions.length > 0 && newCardId) {
            const selectedOption = accountCardOptions.find((opt) => opt.cardId === newCardId.cardId);
            if (selectedOption) {
                if (addCardContext && addCardContext.targetField) {
                    // Assign the newly added card to the specific row/field (debit/credit)
                    handleItemChange(
                        addCardContext.itemType,
                        addCardContext.idx,
                        addCardContext.targetField,
                        selectedOption.cardId
                    );
                } else {
                    // Select on the main Client/Provider field with formatted option
                    const formattedSelected = formattedAccountCardOptions?.find(
                        (opt) => opt.cardId === selectedOption.cardId || opt.value === selectedOption.cardId
                    );
                    if (formattedSelected) {
                        handleMuiChange(null, formattedSelected);
                    }
                }
            }
            // close modal
            setAddNewAccountCardDocument(false);
            setNewCardId(null);
            setAddCardContext(null);
        }
    }, [accountCardOptions, newCardId, addCardContext, handleItemChange, handleMuiChange, formattedAccountCardOptions]);

    const handleAddAccountCardFromItem = (itemType, idx, targetField, initialName) => {
        setShowAccountCardInputsEdit(false);
        setAddNewAccountCardDocument(true);
        setAddCardContext({ itemType, idx, targetField });
        setNewAccountCard({
            accountCodeName: initialName || '',
            accountCodeId: cardIdOption,
            accountCaseId: '',
        });
    };

    useEffect(() => {
        document.body.appendChild(container);
        return () => {
            try {
                document.body.removeChild(container);
            } catch (err) {
                // ignore
            }
        };
    }, [container]);

    useEffect(() => {
        // find the max ID for creating new account
        if (accountCardOptions && accountCardOptions.length > 0) {
            const maxCardId = Math.max(...accountCardOptions.slice(1).map((option) => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);
        }
    }, [accountCardOptions]);

    useEffect(() => {
        // Initialize month date fields from sortDate if available
        if (sortDate && !itemEditing) {
            handleAddEditableItemChange('registrationMonthDate', sortDate);
            handleAddEditableItemChange('reportingMonthDate', sortDate);
            handleAddEditableItemChange('uploadDate', new Date());
        }
    }, [sortDate, itemEditing]);

    useEffect(() => {
        // Update direction based on the current language
        if (!subAccountantOptions) {
            fetchSubAccountants();
        } else {
            setSubAccountantNewOptions(subAccountantOptions);
        }
    }, [subAccountantOptions]);

    const handleCloseItem = () => {
        setShowAccountCardInputsEdit(false);
        setAddNewAccountCardDocument(false);
    };

    // Chat functionality
    const handleSendToChat = async () => {
        try {
            // First, open chat with the client
            await selectUserAndOpenChat(client.caseId, client.name || 'Client');

            // If there's a document URL, send the file to chat
            if (addEditableItem?.receiptDocumentUrl) {
                // Create a file from the document URL
                const response = await fetch(addEditableItem.receiptDocumentUrl);
                const blob = await response.blob();
                const file = new File([blob], `${addEditableItem.description || 'receipt'}.pdf`, { type: 'application/pdf' });

                // Send the file to chat
                await handleSendMessageToChat(file, client.caseId, client.name);
            } else {
                // Just open the chat without sending a file
                toast.success(t('ChatOpenedWithClient'));
            }
        } catch (error) {
            console.error('Error opening chat or sending document:', error);
            toast.error(t('ErrorSendingToChat'));
        }
    };

    const handleNextDoc = () => {
        if (docIndex < allDocUrls.length - 1) {
            setDocIndex(docIndex + 1);
        }
    };

    const handlePrevDoc = () => {
        if (docIndex > 0) {
            setDocIndex(docIndex - 1);
        }
    };

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight') handleNextDoc();
            if (e.key === 'ArrowLeft') handlePrevDoc();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [docIndex]);

    // make a use effect for addEditableItem to log it


    const inputPropsStyle = {
        disableUnderline: true,
    };

    const inputStyle = {
        style: { textAlign: direction === 'rtl' ? 'right' : 'left' },
    };

    const renderComboPopper = useCallback(
        (props) => <ComboPopper {...props} direction={direction} />,
        [direction]
    );

    const datePickerFieldClassName = `edit-style-input ${paStyles.dateField}`;
    const datePickerInputSx = {
        border: '0 !important',
        borderRadius: '0 !important',
        background: '#f5f5f6 !important',
        height: '36px',
        minHeight: '36px',
        boxSizing: 'border-box',
        boxShadow: 'none !important',
        outline: 'none !important',
        padding: '0 8px',
        fontSize: '15px',
        fontWeight: 500,
        '&:hover, &:focus, &.Mui-focused, &:focus-within': {
            border: '0 !important',
            boxShadow: 'none !important',
            outline: 'none !important',
        },
        '&::before, &::after': {
            display: 'none !important',
            border: '0 !important',
        },
        '& fieldset': {
            border: '0 !important',
        },
        '& input': {
            fontSize: '15px !important',
            fontWeight: 500,
        },
        '& .MuiInputAdornment-root': {
            height: '100%',
            maxHeight: 'none',
            margin: 0,
        },
        '& .MuiIconButton-root': {
            padding: '2px',
            margin: 0,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            width: '22px',
            height: '22px',
        },
    };

    const renderTableRows = () => {
        return combinedItems.map((row, index) => {
            const isDisabled = isDisabledForm;
            const isSingleBankLine = Boolean(singleBankLine)
                && (row.itemType === 'checks' || row.itemType === 'bankTransactions') && row.itemTypeIndex === 0;
            const lineOcrField = (field) => (isSingleBankLine ? field : undefined);
            return (
                <StyledTableRow key={row.id || `${row.itemType}-${index}`}>
                    {/* Type */}
                    <StyledTableCell className={paStyles.colType}>
                        <ClearTooltip title={t(row.itemType)} placement="top">
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '100%'
                            }}>
                                {t(row.itemType)}
                            </div>
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* CheckNumber or Description */}
                    <StyledTableCell className={paStyles.colDescription}>
                        {row.itemType === 'checks' ? (
                            <TextField
                                className={fieldStyles.styleInput}
                                fullWidth
                                placeholder={t('CheckNumber')}
                                value={row.description || ''}
                                onChange={(e) => handleItemChange('checks', row.itemTypeIndex, 'description', e.target.value)}
                                variant="standard"
                                InputProps={inputPropsStyle}
                                inputProps={inputStyle}
                                disabled={isDisabled}
                            />
                        ) : (
                            <TextField
                                className={fieldStyles.styleInput}
                                fullWidth
                                placeholder={t('Description')}
                                value={row.description || ''}
                                onChange={(e) => handleItemChange(row.itemType, row.itemTypeIndex, 'description', e.target.value)}
                                variant="standard"
                                InputProps={inputPropsStyle}
                                inputProps={inputStyle}
                                disabled={isDisabled}
                            />
                        )}
                    </StyledTableCell>

                    {/* BankName (checks and bank transfers) — the bank code is chosen here */}
                    <StyledTableCell className={paStyles.colBankName} data-ocr-field={lineOcrField('line.bankCode')}>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <ClearTooltip
                                title={
                                    row.bankName
                                        ? `${row.bankCode || ''} – ${row.bankName}`.replace(/^ – /, '')
                                        : t('BankName')
                                }
                                placement="top"
                            >
                                <span style={{ display: 'block', width: '100%' }}>
                                <Autocomplete
                                    className={fieldStyles.combo}
                                    size="small"
                                    options={Constants.ISRAEL_BANKS}
                                    getOptionLabel={(o) => `${o.code} – ${o.name}`}
                                    value={
                                        Constants.ISRAEL_BANKS.find(
                                            (b) => b.code === row.bankCode || b.name === row.bankName
                                        ) || null
                                    }
                                    onChange={(_, newVal) => {
                                        handleItemChange(row.itemType, row.itemTypeIndex, 'bankName', newVal ? newVal.name : '');
                                        handleItemChange(row.itemType, row.itemTypeIndex, 'bankCode', newVal ? newVal.code : '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className={fieldStyles.styleInput}
                                            placeholder={t('BankName')}
                                            variant="standard"
                                            InputProps={{
                                                ...params.InputProps,
                                                ...inputPropsStyle,
                                            }}
                                            inputProps={{
                                                ...params.inputProps,
                                                ...inputStyle,
                                            }}
                                            disabled={isDisabled}
                                        />
                                    )}
                                    isOptionEqualToValue={(o, v) => o.code === v.code}
                                    disabled={isDisabled}
                                    noOptionsText={t('SelectBank')}
                                    PopperComponent={renderComboPopper}
                                    ListboxProps={{ direction }}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{ direction: direction === 'ltr' ? 'ltr' : 'rtl' }}>
                                            {option.code} – {option.name}
                                        </li>
                                    )}
                                    disablePortal={false}
                                />
                                </span>
                            </ClearTooltip>
                        ) : (
                            <ClearTooltip title="-" placement="top">
                                <span>-</span>
                            </ClearTooltip>
                        )}
                        {lineOcrField('line.bankCode') && <FieldBoxDot field="line.bankCode" placement="corner" endOffset={4} />}
                    </StyledTableCell>

                    {/* BankCode (checks and bank transfers) */}
                    <StyledTableCell className={paStyles.colBankCode}>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <ClearTooltip title={row.bankCode || t('BankCode')} placement="top">
                                <TextField
                                    className={fieldStyles.styleInput}
                                    fullWidth
                                    type="number"
                                    placeholder={t('BankCode')}
                                    value={row.bankCode || ''}
                                    onChange={(e) => handleItemChange(row.itemType, row.itemTypeIndex, 'bankCode', e.target.value)}
                                    variant="standard"
                                    InputProps={inputPropsStyle}
                                    inputProps={inputStyle}
                                    disabled
                                />
                            </ClearTooltip>
                        ) : (
                            <ClearTooltip title="-" placement="top">
                                <span>-</span>
                            </ClearTooltip>
                        )}
                    </StyledTableCell>

                    <StyledTableCell className={paStyles.colBankBranch} data-ocr-field={lineOcrField('line.bankBranchCode')}>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <ClearTooltip title={row.bankBranchCode || t('BankBranchCode')} placement="top">
                                <TextField
                                    className={fieldStyles.styleInput}
                                    fullWidth
                                    type="number"
                                    placeholder={t('BankBranchCode')}
                                    value={row.bankBranchCode || ''}
                                    onChange={(e) => handleItemChange(row.itemType, row.itemTypeIndex, 'bankBranchCode', e.target.value)}
                                    variant="standard"
                                    InputProps={inputPropsStyle}
                                    inputProps={inputStyle}
                                    disabled={isDisabled}
                                />
                            </ClearTooltip>
                        ) : (
                            <ClearTooltip title="-" placement="top">
                                <span>-</span>
                            </ClearTooltip>
                        )}
                        {lineOcrField('line.bankBranchCode') && <FieldBoxDot field="line.bankBranchCode" placement="corner" endOffset={4} />}
                    </StyledTableCell>
                    <StyledTableCell className={paStyles.colBankAccount} data-ocr-field={lineOcrField('line.supplierAccountNumber')}>
                        {(row.itemType === 'checks' || row.itemType === 'bankTransactions') ? (
                            <ClearTooltip title={row.supplierAccountNumber || t('SupplierAccountNumber')} placement="top">
                                <TextField
                                    className={fieldStyles.styleInput}
                                    fullWidth
                                    type="number"
                                    placeholder={t('SupplierAccountNumber')}
                                    value={row.supplierAccountNumber || ''}
                                    onChange={(e) => handleItemChange(row.itemType, row.itemTypeIndex, 'supplierAccountNumber', e.target.value)}
                                    variant="standard"
                                    InputProps={inputPropsStyle}
                                    inputProps={inputStyle}
                                    disabled={isDisabled}
                                />
                            </ClearTooltip>
                        ) : (
                            <ClearTooltip title="-" placement="top">
                                <span>-</span>
                            </ClearTooltip>
                        )}
                        {lineOcrField('line.supplierAccountNumber') && <FieldBoxDot field="line.supplierAccountNumber" placement="corner" endOffset={4} />}
                    </StyledTableCell>

                    {/* Amount */}
                    <StyledTableCell className={paStyles.colAmount}>
                        <ClearTooltip title={row.amount || t('Amount')} placement="top">
                            <TextField
                                className={fieldStyles.styleInput}
                                fullWidth
                                type="number"
                                placeholder={t('Amount')}
                                value={row.amount ?? ''}
                                onChange={e => handleAmountChange(row.itemType, row.itemTypeIndex, e.target.value)}
                                variant="standard"
                                InputProps={inputPropsStyle}
                                inputProps={inputStyle}
                                disabled={isDisabled}
                            />
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* ForeignAmount */}
                    <StyledTableCell className={paStyles.colCurrencyAmount}>
                        <ClearTooltip title={row.foreignCurrencyAmount || t('CurrencyAmount')} placement="top">
                            <TextField
                                className={fieldStyles.styleInput}
                                fullWidth
                                type="number"
                                placeholder={t('CurrencyAmount')}
                                value={row.foreignCurrencyAmount ?? ''}
                                onChange={(e) => handleForeignAmountChange(row.itemType, row.itemTypeIndex, e.target.value)}
                                variant="standard"
                                InputProps={{
                                    ...inputPropsStyle,
                                    endAdornment: (isLoadingFCRate || loadingCurrencyRateFor[`${row.itemType}-${row.itemTypeIndex}`]) ? (
                                        <InputAdornment position="end">
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CircularProgress size={22} />
                                                <span style={{ fontSize: '0.75rem', color: '#666' }}>
                                                    {t('FetchingCurrencyRateByReceiptPaymentDate', {
                                                        dateType: addEditableItem.paymentAcceptanceType === 'תשלום' ? t('PaymentDate') : t('ReceiptDateType'),
                                                    })}
                                                </span>
                                            </Box>
                                        </InputAdornment>
                                    ) : null,
                                }}
                                inputProps={inputStyle}
                                disabled={isDisabled || isLoadingFCRate}
                            />
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* reference */}
                    <StyledTableCell className={paStyles.colReference2}>
                        <ClearTooltip title={row.reference2 || t('Reference2')} placement="top">
                            <TextField
                                className={fieldStyles.styleInput}
                                fullWidth
                                type="number"
                                placeholder={t('Reference2')}
                                value={row.reference2 || ''}
                                onChange={(e) => handleItemChange(row.itemType, row.itemTypeIndex, 'reference2', e.target.value)}
                                variant="standard"
                                InputProps={inputPropsStyle}
                                inputProps={inputStyle}
                                disabled={isDisabled}
                            />
                        </ClearTooltip>
                    </StyledTableCell>



                    {/* Payment Date */}
                    <StyledTableCell className={paStyles.colDueDate}>
                        <ClearTooltip title={row.paymentDate ? formatTooltipDate(row.paymentDate) : t('DuePaymentDate')} placement="top">
                            <span style={{ display: 'block', width: '100%' }}>
                                <CustomDatePicker
                                    date={row.paymentDate ? row.paymentDate : null}
                                    onDateChange={(dateVal) => handlePaymentDateChange(row.itemType, row.itemTypeIndex, dateVal)}
                                    height="36px"
                                    disabled={isDisabled}
                                    textFieldClassName={datePickerFieldClassName}
                                    inputSx={datePickerInputSx}
                                />
                            </span>
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* Debit Account */}
                    <StyledTableCell className={paStyles.colAccount}>
                        <ClearTooltip title={formattedAccountCardOptions.find((opt) => opt.value === row.debitAccount)?.label || t('Debit Account')} placement="top">
                            <Autocomplete
                                className={fieldStyles.combo}
                                options={formattedAccountCardOptions}
                                getOptionLabel={(option) => {
                                    if (option?.value1 === 'AddItem') {
                                        return `${t('AddAccountCard')} "${option.searchTerm || searchTerm || ''}"`;
                                    }
                                    return option?.label || '';
                                }}
                                filterOptions={filterAccountCardOptions}
                                value={formattedAccountCardOptions.find((opt) => opt.value === row.debitAccount) || null}
                                onChange={(e, selectedOption) => {
                                    if (selectedOption?.value1 === 'AddItem') {
                                        handleAddAccountCardFromItem(row.itemType, row.itemTypeIndex, 'debitAccount', searchTerm);
                                        return;
                                    }
                                    handleItemChange(
                                        row.itemType,
                                        row.itemTypeIndex,
                                        'debitAccount',
                                        selectedOption ? selectedOption.value : ''
                                    );
                                }}
                                onInputChange={(event, inputValue) => setSearchTerm(inputValue)}
                                disablePortal={false}
                                disableListWrap
                                ListboxComponent={FixedSizeVirtualizedListbox}
                                ListboxProps={{ direction, itemHeight: 36, listHeight: 280 }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className={fieldStyles.styleInput}
                                        variant="standard"
                                        placeholder={t('Debit Account')}
                                        InputProps={{ ...params.InputProps, ...inputPropsStyle }}
                                        inputProps={{ ...params.inputProps, ...inputStyle }}
                                    />
                                )}
                                renderOption={(props, option) => {
                                    if (option?.value1 === 'AddItem') {
                                        const { key, className, ...optionProps } = props;
                                        return (
                                            <li
                                                key={key}
                                                {...optionProps}
                                                className={`${className || ''} edit-add-account-option`}
                                            >
                                                <AddAccountCardOptionContent
                                                    label={t('AddAccountCard')}
                                                    searchTerm={option.searchTerm || searchTerm}
                                                />
                                            </li>
                                        );
                                    }
                                    return (
                                        <ClearTooltip
                                            title={
                                                option.isEditable
                                                    ? t('RightClickToEdit')
                                                    : t('NotEditable')
                                            }
                                            placement="top"
                                        >
                                            <StyledListItem
                                                {...props}
                                                onContextMenu={(event) => {
                                                    event.preventDefault();
                                                    setAddCardContext({ itemType: row.itemType, idx: row.itemTypeIndex, targetField: 'debitAccount' });
                                                    setPalCode(option.palCode);
                                                    setNewAccountCard({
                                                        accountCodeName: option.name || '',
                                                        accountCodeId: option.cardId,
                                                        accountCaseId: option.accountCaseId || '',
                                                        isEditable: option.isEditable,
                                                    });
                                                    setShowAccountCardInputsEdit(true);
                                                    setAddNewAccountCardDocument(true);
                                                }}
                                            >
                                                {`${option?.cardId || ''} - ${option.name}`}
                                            </StyledListItem>
                                        </ClearTooltip>
                                    );
                                }}
                                PopperComponent={renderComboPopper}
                                noOptionsText={
                                    <button
                                        type="button"
                                        className="edit-add-account-empty"
                                        onClick={() => handleAddAccountCardFromItem(row.itemType, row.itemTypeIndex, 'debitAccount', searchTerm)}
                                    >
                                        <AddAccountCardOptionContent
                                            label={t('AddAccountCard')}
                                            searchTerm={searchTerm}
                                        />
                                    </button>
                                }
                                disabled={isDisabled}
                            />
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* Credit Account */}
                    <StyledTableCell className={paStyles.colAccount}>
                        <ClearTooltip title={formattedAccountCardOptions.find((opt) => opt.value === row.creditAccount)?.label || t('Credit Account')} placement="top">
                            <Autocomplete
                                className={fieldStyles.combo}
                                options={formattedAccountCardOptions}
                                getOptionLabel={(option) => {
                                    if (option?.value1 === 'AddItem') {
                                        return `${t('AddAccountCard')} "${option.searchTerm || searchTerm || ''}"`;
                                    }
                                    return option?.label || '';
                                }}
                                filterOptions={filterAccountCardOptions}
                                value={formattedAccountCardOptions.find((opt) => opt.value === row.creditAccount) || null}
                                onChange={(e, selectedOption) => {
                                    if (selectedOption?.value1 === 'AddItem') {
                                        handleAddAccountCardFromItem(row.itemType, row.itemTypeIndex, 'creditAccount', searchTerm);
                                        return;
                                    }
                                    handleItemChange(
                                        row.itemType,
                                        row.itemTypeIndex,
                                        'creditAccount',
                                        selectedOption ? selectedOption.value : ''
                                    );
                                }}
                                onInputChange={(event, inputValue) => setSearchTerm(inputValue)}
                                disablePortal={false}
                                disableListWrap
                                ListboxComponent={FixedSizeVirtualizedListbox}
                                ListboxProps={{ direction, itemHeight: 36, listHeight: 280 }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className={fieldStyles.styleInput}
                                        variant="standard"
                                        placeholder={t('Credit Account')}
                                        InputProps={{ ...params.InputProps, ...inputPropsStyle }}
                                        inputProps={{ ...params.inputProps, ...inputStyle }}
                                    />
                                )}
                                renderOption={(props, option) => {
                                    if (option?.value1 === 'AddItem') {
                                        const { key, className, ...optionProps } = props;
                                        return (
                                            <li
                                                key={key}
                                                {...optionProps}
                                                className={`${className || ''} edit-add-account-option`}
                                            >
                                                <AddAccountCardOptionContent
                                                    label={t('AddAccountCard')}
                                                    searchTerm={option.searchTerm || searchTerm}
                                                />
                                            </li>
                                        );
                                    }
                                    return (
                                        <ClearTooltip
                                            title={
                                                option.isEditable
                                                    ? t('RightClickToEdit')
                                                    : t('NotEditable')
                                            }
                                            placement="top"
                                        >
                                            <StyledListItem
                                                {...props}
                                                onContextMenu={(event) => {
                                                    event.preventDefault();
                                                    setAddCardContext({ itemType: row.itemType, idx: row.itemTypeIndex, targetField: 'creditAccount' });
                                                    setPalCode(option.palCode);
                                                    setNewAccountCard({
                                                        accountCodeName: option.name || '',
                                                        accountCodeId: option.cardId,
                                                        accountCaseId: option.accountCaseId || '',
                                                        isEditable: option.isEditable,
                                                    });
                                                    setShowAccountCardInputsEdit(true);
                                                    setAddNewAccountCardDocument(true);
                                                }}
                                            >
                                                {`${option?.cardId || ''} - ${option.name}`}
                                            </StyledListItem>
                                        </ClearTooltip>
                                    );
                                }}
                                PopperComponent={renderComboPopper}
                                noOptionsText={
                                    <button
                                        type="button"
                                        className="edit-add-account-empty"
                                        onClick={() => handleAddAccountCardFromItem(row.itemType, row.itemTypeIndex, 'creditAccount', searchTerm)}
                                    >
                                        <AddAccountCardOptionContent
                                            label={t('AddAccountCard')}
                                            searchTerm={searchTerm}
                                        />
                                    </button>
                                }
                                disabled={isDisabled}
                            />
                        </ClearTooltip>
                    </StyledTableCell>

                    {/* Remove button */}
                    <StyledTableCell className={paStyles.colActions}>
                        {!isDisabled && (
                            <ClearTooltip title={t('Delete')} placement="top">
                                <Button
                                    style={{ color: 'red', minWidth: '20px' }}
                                    onClick={() => handleRemovePaymentLine(row.itemType, row.itemTypeIndex)}
                                    size="small"
                                >
                                    <DeleteIcon style={{ fontSize: '18px' }} />
                                </Button>
                            </ClearTooltip>
                        )}
                    </StyledTableCell>
                </StyledTableRow>
            );
        });
    };

    const paymentTypeOptions = [
        { value: t('Approval'), label: t('Approval') },
        { value: t('Payment'), label: t('Payment') },
    ];

    const isLocked = !!addEditableItem?.isLocked;
    /* Same source as parent pages: !isRange → page-level closed flag; isRange → per-item flag */
    const monthClosedForForm = !!isClosedReportingMonthAndIsRange;
    const ut = userTypeContext?.toString();
    const canEditWhenClosedMonth =
        ut === Constants.UserType.Accountant ||
        ut === Constants.UserType.SubAccountant;
    /* Full-form edit disabled when locked, or closed month for non-accountants.
       Metadata (dates + description) stays open; reporting month is frozen when closed. */
    const isDisabledForm =
        isLocked || (monthClosedForForm && !canEditWhenClosedMonth);
    const isDisabledLockedMetadataFields = false;
    const isDisabledReportingMonthDate = monthClosedForForm;
    // Allow save of metadata when locked/closed; still block create while form is restricted
    const isSaveBlocked = isDisabledForm && !itemEditing;

    const deductionRatePercent = useMemo(
        () => readDeductionRate(accountCardOptions?.find((opt) => opt.cardId === addEditableItem?.accountCodeId)),
        [accountCardOptions, addEditableItem?.accountCodeId]
    );

    const withholdingRow = usePaymentWithholdingRow({
        withholdingTax: addEditableItem?.withholdingTax,
        deductionRatePercent,
        amounts,
        // The hosts keep their own copy of the deduction, so go through their change handler.
        onWithholdingChange: (value) => handleChangeOriginalTaxClearance({ target: { value: String(value ?? '') } }),
    });

    const showProjectAssignRow = Boolean(client?.caseId && token && client?.managesProject);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [projectModalOpen, setProjectModalOpen] = useState(false);
    const [projectCreateLoading, setProjectCreateLoading] = useState(false);
    const [projectAssignLoading, setProjectAssignLoading] = useState(false);
    const [projectModalPortalContainer] = useState(() => document.createElement('div'));

    const projectAutocompleteOptions = useMemo(
        () => [
            { id: '__ADD_NEW__', label: t('AddProject'), kind: 'add' },
            ...segmentationProjects.map((p) => ({
                id: String(p.id ?? ''),
                label: `${p.code} — ${p.name}`,
                kind: 'project',
            })),
        ],
        [segmentationProjects, t]
    );

    const assignedProjectIdStr = useMemo(
        () => getAssignedProjectIdFromItem(addEditableItem),
        [addEditableItem]
    );

    const selectedProjectAutocompleteValue = useMemo(() => {
        if (!assignedProjectIdStr) return null;
        const matchedOption = projectAutocompleteOptions.find(
            (o) => o.kind === 'project' && String(o.id) === String(assignedProjectIdStr)
        );
        if (matchedOption) return matchedOption;

        const code = addEditableItem?.segmentationCode ?? addEditableItem?.SegmentationCode ?? '';
        const name = addEditableItem?.segmentationName ?? addEditableItem?.SegmentationName ?? '';
        const label =
            `${code} — ${name}`.replace(/^ — | — $/g, '').trim() || String(assignedProjectIdStr);

        return {
            id: String(assignedProjectIdStr),
            label,
            kind: 'project',
        };
    }, [
        assignedProjectIdStr,
        projectAutocompleteOptions,
        addEditableItem?.segmentationCode,
        addEditableItem?.SegmentationCode,
        addEditableItem?.segmentationName,
        addEditableItem?.SegmentationName,
    ]);

    const fetchSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) {
            setSegmentationProjects([]);
            return;
        }
        try {
            const res = await ProjectsService.getProjects(client.caseId, token);
            if (!res.ok) return;
            const data = await res.json();
            const list = (Array.isArray(data) ? data : [])
                .map(normalizeSegmentationProjectRow)
                .filter((p) => p.id);
            setSegmentationProjects(list);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    }, [client?.caseId, token]);

    useEffect(() => {
        if (!showProjectAssignRow) return;
        void fetchSegmentationProjects();
    }, [showProjectAssignRow, fetchSegmentationProjects]);

    useEffect(() => {
        if (!projectModalOpen) return undefined;
        document.body.appendChild(projectModalPortalContainer);
        return () => {
            try {
                document.body.removeChild(projectModalPortalContainer);
            } catch {
                // ignore
            }
        };
    }, [projectModalOpen, projectModalPortalContainer]);

    const applyProjectToItem = useCallback(
        (newSegmentationId, optionalProjectMeta = null) => {
            const newId = newSegmentationId ? String(newSegmentationId) : '';
            const meta =
                optionalProjectMeta ||
                segmentationProjects.find((p) => String(p.id) === newId);
            const patch = {
                projects: newId
                    ? [{ projectId: newId, code: meta?.code ?? '', name: meta?.name ?? '' }]
                    : [],
                segmentationId: newId || null,
                SegmentationId: newId || null,
                segmentationCode: newId ? meta?.code ?? '' : null,
                segmentationName: newId ? meta?.name ?? '' : null,
            };
            patchAddEditableItem(patch);
        },
        [segmentationProjects, patchAddEditableItem]
    );

    const applyProjectSelection = useCallback(
        async (newSegmentationId, optionalProjectMeta = null) => {
            const item = addEditableItemRef.current;
            if (!client?.caseId || !token || !item?.id) {
                return;
            }

            const newId = newSegmentationId ? String(newSegmentationId) : '';
            const oldId = getAssignedProjectIdFromItem(item);
            if (oldId === newId) return;

            setProjectAssignLoading(true);
            try {
                if (oldId) {
                    const removeRes = await ProjectsService.removePaymentAcceptanceFromSegmentation(
                        oldId,
                        client.caseId,
                        item.id,
                        token
                    );
                    if (!removeRes.ok) {
                        let errText = '';
                        try {
                            errText = await removeRes.text();
                        } catch {
                            /* ignore */
                        }
                        toast.error(errText || t('ErrorUpdatingProject'));
                        return;
                    }
                }
                if (newId) {
                    const payload = {
                        SegmentationId: newId,
                        CaseId: client.caseId,
                        PaymentAcceptanceIds: [item.id],
                    };
                    const addRes = await ProjectsService.assignDocuments(payload, token);
                    if (!addRes.ok) {
                        let errText = '';
                        try {
                            errText = await addRes.text();
                        } catch {
                            /* ignore */
                        }
                        toast.error(errText || t('ErrorUpdatingProject'));
                        return;
                    }
                }

                const meta =
                    optionalProjectMeta ||
                    segmentationProjects.find((p) => String(p.id) === newId);
                applyProjectToItem(newId, meta);
            } catch (e) {
                console.error(e);
                toast.error(t('ErrorUpdatingProject'));
            } finally {
                setProjectAssignLoading(false);
            }
        },
        [client?.caseId, token, t, segmentationProjects, applyProjectToItem]
    );

    const handleProjectAutocompleteChange = (_event, newValue) => {
        if (newValue?.kind === 'add' || newValue?.id === '__ADD_NEW__') {
            setProjectModalOpen(true);
            return;
        }
        if (!newValue || newValue.kind === 'none' || newValue.id === '') {
            if (addEditableItemRef.current?.id) {
                void applyProjectSelection('');
            } else {
                applyProjectToItem('');
            }
            return;
        }
        const projectId = String(newValue.id);
        if (addEditableItemRef.current?.id) {
            void applyProjectSelection(projectId);
        } else {
            applyProjectToItem(projectId);
        }
    };

    const handleProjectModalClose = () => {
        setProjectModalOpen(false);
    };

    const handleProjectModalSave = async (projectInput) => {
        if (!client?.caseId || !token) return false;
        const drafts = Array.isArray(projectInput) ? projectInput : [projectInput];
        const normalized = drafts.map((d) => ({
            code: String(d?.code ?? '').trim(),
            name: String(d?.name ?? '').trim(),
        }));
        if (normalized.some((d) => !d.code || !d.name)) return false;

        setProjectCreateLoading(true);
        try {
            let lastCreated = null;
            for (const draft of normalized) {
                const res = await ProjectsService.createProject(
                    { CaseId: client.caseId, Code: draft.code, Name: draft.name },
                    token
                );
                if (!res.ok) {
                    const msg = await res.text();
                    toast.error(msg || t('ErrorCreatingProject'));
                    await fetchSegmentationProjects();
                    return false;
                }
                lastCreated = normalizeSegmentationProjectRow(await res.json());
            }
            toast.success(`${t('Add')} ${t('Projects')}`);
            await fetchSegmentationProjects();
            setProjectModalOpen(false);
            if (lastCreated?.id) {
                if (addEditableItemRef.current?.id) {
                    await applyProjectSelection(String(lastCreated.id), {
                        code: lastCreated.code,
                        name: lastCreated.name,
                    });
                } else {
                    applyProjectToItem(String(lastCreated.id), {
                        code: lastCreated.code,
                        name: lastCreated.name,
                    });
                }
            }
            return true;
        } catch (e) {
            console.error(e);
            toast.error(t('ErrorCreatingProject'));
            return false;
        } finally {
            setProjectCreateLoading(false);
        }
    };

    const [validationResult, setValidationResult] = useState([]);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const [reportingMonthDatePickerKey, setReportingMonthDatePickerKey] = useState(0);
    
    // For file upload functionality
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    // File upload handlers
    const onDrop = useCallback((acceptedFiles) => {
        setIsDragging(false);
        if (acceptedFiles.length > 0) {
            const newDocuments = [...documents, ...acceptedFiles];
            setDocuments(newDocuments);
        }
    }, [documents]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        onDragEnter: () => setIsDragging(true),
        onDragLeave: () => setIsDragging(false),
    });

    const handleRemoveDocument = (index) => {
        setDocuments(documents.filter((_, i) => i !== index));
    };

    const handleReportingMonthDateChange = async (date) => {
        if (date) {
            const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
            const response = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
            if (response.ok) {
                const isClosedReportingMonth = await response.json();
                if (isClosedReportingMonth) {
                    toast.info(t('MonthReportAlreadyClosedTryAgain'));
                    // Force the date picker to re-render with the old value
                    setReportingMonthDatePickerKey(prev => prev + 1);
                    return; // Don't update the date
                }
            }
            // If the month is not closed, update the date
            handleAddEditableItemChange('reportingMonthDate', date);
        }
    };

    const handleUploadDocuments = async () => {
        if (documents.length === 0) {
            toast.warning(t('PleaseUploadAtLeastOneDocument'));
            return;
        }

        try {
            setLoading(true);
            
            const formData = new FormData();
            
            // Append all document fields - PaymentAcceptance doesn't have all fields like Income/Expense
            // We'll use a simplified approach for PaymentAcceptance
            formData.append('Id', addEditableItem.id);
            formData.append('CaseId', addEditableItem.caseId);
            formData.append('DocumentType', 'PaymentAcceptance');
            formData.append('SortCodeId', '');
            formData.append('Description', addEditableItem.description || '');
            formData.append('Reference', addEditableItem.reference || '');
            formData.append('Reference2', '');
            formData.append('Amount', addEditableItem.amount || 0);
            formData.append('VAT', 100);
            formData.append('DocumentDate', addEditableItem.date ? new Date(addEditableItem.date).toISOString() : new Date().toISOString());
            formData.append('UploadDate', addEditableItem.uploadDate ? new Date(addEditableItem.uploadDate).toISOString() : new Date().toISOString());
            formData.append('ReportingMonthDate', addEditableItem.reportingMonthDate ? new Date(addEditableItem.reportingMonthDate).toISOString() : new Date().toISOString());
            formData.append('RegistrationMonthDate', addEditableItem.registrationMonthDate ? new Date(addEditableItem.registrationMonthDate).toISOString() : new Date().toISOString());
            formData.append('CreditAccount', '');
            formData.append('DebitAccount', '');
            formData.append('UploadNumber', addEditableItem.uploadNumber || 0);
            formData.append('AccountCaseId', addEditableItem.accountCaseId || '');
            formData.append('ConfirmationNumber', '');
            formData.append('AccountCodeId', addEditableItem.accountCodeId || '');
            formData.append('AccountCodeName', addEditableItem.accountCodeName || '');
            
            // Foreign currency fields
            if (addEditableItem.foreignCurrencyAmount !== null && addEditableItem.foreignCurrencyAmount !== undefined) {
                formData.append('ForeignCurrencyAmount', addEditableItem.foreignCurrencyAmount);
            }
            if (addEditableItem.foreignCurrencyCode !== null && addEditableItem.foreignCurrencyCode !== undefined) {
                formData.append('ForeignCurrencyCode', addEditableItem.foreignCurrencyCode);
            }
            if (addEditableItem.exchangeRateType !== null && addEditableItem.exchangeRateType !== undefined) {
                formData.append('ExchangeRateType', addEditableItem.exchangeRateType);
            }
            if (addEditableItem.exchangeRate !== null && addEditableItem.exchangeRate !== undefined) {
                formData.append('ExchangeRate', addEditableItem.exchangeRate);
            }

            // Append all documents
            documents.forEach((doc, index) => {
                formData.append('Documents', doc);
            });

            const response = await DocumentService.uploadOrMergeDocument(formData, token);
            
            if (response.ok) {
                const result = await response.json();
                
                // Update the addEditableItem with the new documentUrl (presigned URL)
                if (result.data && result.data.presignedUrl) {
                    handleAddEditableItemChange('receiptDocumentUrl', result.data.presignedUrl);
                }
                
                // Close the upload modal
                setUploadModalOpen(false);
                setDocuments([]);
                
                // Refresh the data
                await handleTransferRefresh();
                
                // Show success toast
                toast.success(t('documentUploadedSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('ErrorUploadingFiles') + ': ' + errorText);
            }
        } catch (error) {
            console.error('Error uploading documents:', error);
            toast.error(t('ErrorUploadingFiles'));
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteDocumentUrl = async () => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: t('AreYouSure'),
                text: t('DeleteDocumentUrlConfirmation'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: t('YesDeleteIt'),
                cancelButtonText: t('NoCancel'),
                customClass: {
                    container: 'swal-high-zindex'
                }
            });

            if (result.isConfirmed) {
                setLoading(true);
                
                const response = await DocumentService.deleteDocumentUrl(
                    addEditableItem.id,
                    addEditableItem.caseId,
                    'PaymentAcceptance',
                    token
                );
                
                if (response.ok) {
                    // Clear the documentUrl from state
                    handleAddEditableItemChange('receiptDocumentUrl', null);
                    setShowPdfIframe(false);
                    
                    // Refresh the data
                    await handleTransferRefresh();
                    
                    toast.success(t('DocumentUrlDeletedSuccessfully'));
                } else {
                    const errorText = await response.text();
                    toast.error(t('ErrorDeletingDocumentUrl') + ': ' + errorText);
                }
            }
        } catch (error) {
            console.error('Error deleting document URL:', error);
            toast.error(t('ErrorDeletingDocumentUrl'));
        } finally {
            setLoading(false);
        }
    };

    const saveDuplicate = async (patchOrPatches) => {
        setLoading(true);
        try {
            // PaymentAcceptances docType
            const docType = 'PaymentAcceptances';

            // Check if patchOrPatches is an array (batch save) or single object
            const isBatchSave = Array.isArray(patchOrPatches);

            if (isBatchSave) {
                // Batch duplicate: create multiple documents
                const result = await DocumentService.BatchDuplicateDocuments(
                    docType,
                    addEditableItem.id,       // sourceId to duplicate from
                    patchOrPatches,      // array of patches
                    client.caseId,
                    token
                );

                if (result.ok) {
                    toast.success(t("batchDuplicateSuccess") || `Successfully duplicated ${result.successCount} entries`);
                    await handleTransferRefresh();
                } else {
                    const errorMsg = result.errors.length > 0 
                        ? `Failed: ${result.errors.length} of ${result.totalCount}` 
                        : 'Batch duplicate failed';
                    toast.error(`${t("batchDuplicateError") || 'Batch duplicate error'}: ${errorMsg}`);
                }
            } else {
                // Single duplicate
                const res = await DocumentService.DuplicateDocument(
                    docType,             // "PaymentAcceptances"
                    addEditableItem.id,       // sourceId
                    patchOrPatches,      // may be {} or null
                    client.caseId,
                    token
                );

                if (res.ok) {
                    toast.success(t("documentDuplicateSuccess"));
                    await handleTransferRefresh();
                } else {
                    const msg = await res.text();
                    toast.error(`${t("documentDuplicateError")}: ${msg}`);
                }
            }
        } catch (err) {
            toast.error(`${t("documentDuplicateError")}: ${err.message}`);
        } finally {
            setLoading(false);
            closeDuplicate();
        }
    };

    useEffect(() => {
        const validate = () => {
            const errors = [];
            if (!addEditableItem.accountCodeId) {
                errors.push(t('ClientNameIsRequired'));
            }
            if (!addEditableItem.paymentAcceptanceType) {
                errors.push(t('PaymentTypeIsRequired'));
            }
            if (!addEditableItem.date) {
                errors.push(t('ReceiptPaymentDateIsRequired'));
            }
            if (!addEditableItem.registrationMonthDate) {
                errors.push(t('RegistrationMonthDateIsRequired'));
            }
            if (!addEditableItem.reportingMonthDate) {
                errors.push(t('MonthReportDateIsRequired'));
            }

            // Validate items (amount and payment date)
            const itemTypes = ['checks', 'creditCards', 'cash', 'bankTransactions', 'offsets'];
            itemTypes.forEach(type => {
                const items = addEditableItem[type] || [];
                items.forEach((item, index) => {
                    if (!item.amount || item.amount === '') {
                        errors.push(t('AmountRequired'));
                    }
                    if (!item.paymentDate) {
                        errors.push(t('PaymentDateRequired'));
                    }
                });
            });

            setValidationResult(errors);
            setIsSaveDisabled(errors.length > 0);
        };

        validate();
    }, [addEditableItem, t]);

    // Own F1–F4 / ESC while this modal is open (yield global nav shortcuts).
    useEffect(() => {
        document.body.setAttribute('data-document-edit-modal-open', 'true');
        return () => {
            document.body.removeAttribute('data-document-edit-modal-open');
        };
    }, []);

    useEffect(() => {
        const normalizeFunctionKey = (e) => {
            if (typeof e?.key === 'string' && /^F\d{1,2}$/.test(e.key)) return e.key;
            if (typeof e?.code === 'string' && /^F\d{1,2}$/.test(e.code)) return e.code;
            return null;
        };

        const hasNestedOverlay = () =>
            uploadModalOpen ||
            projectModalOpen ||
            dupOpen ||
            addNewAccountCardDocument ||
            Swal.isVisible();

        const handleKeyDown = (event) => {
            const fnKey = normalizeFunctionKey(event);

            if (event.key === 'Escape') {
                if (Swal.isVisible()) return;
                if (uploadModalOpen) {
                    setUploadModalOpen(false);
                    setDocuments([]);
                    return;
                }
                if (projectModalOpen) {
                    setProjectModalOpen(false);
                    return;
                }
                if (dupOpen) {
                    setDupOpen(false);
                    return;
                }
                if (addNewAccountCardDocument) {
                    handleCloseItem();
                    return;
                }
                handleClose();
                return;
            }

            if (!fnKey || !['F1', 'F2', 'F3', 'F4'].includes(fnKey)) return;
            if (hasNestedOverlay()) return;

            event.preventDefault();
            event.stopPropagation();

            if (fnKey === 'F1') {
                if (isDisabledForm || !itemEditing || !canProcessStatus) return;
                handleRadioChange({ target: { value: 'done' } }, { forceProcess });
                return;
            }
            if (fnKey === 'F2') {
                // Locked docs can still save date/description metadata.
                if (isSaveBlocked || isSaveDisabled) return;
                if (itemEditing) handleSave();
                else handleClickDoneCreation();
                return;
            }
            if (fnKey === 'F3') {
                if (!itemEditing || !haveNextAndPrevuios) return;
                if (currentIndex == null || currentIndex < 0) return;
                if (currentIndex === filteredAndSortedData.length - 1) return;
                handleNext();
                return;
            }
            if (fnKey === 'F4') {
                if (!itemEditing || !haveNextAndPrevuios) return;
                if (currentIndex == null || currentIndex < 0) return;
                if (currentIndex === 0) return;
                handlePrevious();
            }
        };

        window.addEventListener('keydown', handleKeyDown, true);
        return () => window.removeEventListener('keydown', handleKeyDown, true);
    }, [
        uploadModalOpen,
        projectModalOpen,
        dupOpen,
        addNewAccountCardDocument,
        handleCloseItem,
        handleClose,
        isDisabledForm,
        isSaveBlocked,
        itemEditing,
        canProcessStatus,
        handleRadioChange,
        forceProcess,
        isSaveDisabled,
        handleSave,
        handleClickDoneCreation,
        haveNextAndPrevuios,
        currentIndex,
        filteredAndSortedData,
        handleNext,
        handlePrevious,
    ]);

    return (
        <Portal container={container}>
            <FieldBoxDotProvider
                fields={fieldBoxesShown ? visibleFieldBoxes : null}
                fieldOrder={fieldBoxOrder}
                fieldLabels={fieldBoxLabels}
                activeField={activeOcrField}
                onFieldClick={handleFieldBoxClick}
            >
            <Draggable
                handle=".handle"
                cancel=".edit-modal-no-drag, .edit-modal-close-button, .edit-modal-size-controls, button, .MuiButtonBase-root, .MuiIconButton-root"
                nodeRef={nodeRef}
            >
                {/* 
                    Outer container: a COLUMN layout that can scroll.
                    1) The top row is a flex row with:
                       Left side: Receipt details
                       Right side: PDF preview
                    2) The table is below that entire row. 
                */}
                <div
                    ref={nodeRef}
                    onFocusCapture={fieldPositions ? handleOcrFieldFocus : undefined}
                    onBlurCapture={fieldPositions ? handleOcrFieldBlur : undefined}
                    className={`edit-modal-shell size-${modalSizeMode}${showPdfIframe ? ' with-pdf' : ''}`}
                    style={{
                        padding: '12px',
                        flexDirection: 'column',
                        direction: direction,
                        ...(modalSizeMode === 'free'
                            ? {
                                top: freeSize.top,
                                left: freeSize.left,
                                width: freeSize.width,
                                height: freeSize.height,
                            }
                            : {}),
                    }}
                >
                    {/* ===================== TOP ROW: Side-by-side ===================== */}
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        {/* ===================== LEFT SIDE (Details) ===================== */}
                        <div
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                marginRight: '12px', // Reduced from 16px
                            }}
                        >
                            {/* ---------- HEADER: close/actions outside drag handle (tablet-safe) ---------- */}
                            <div
                                className="edit-modal-header"
                                style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    marginBottom: '12px',
                                    width: '100%',
                                }}
                            >
                                <ClearTooltip title={`${t('Exit')} (ESC)`}>
                                    <button
                                        type="button"
                                        className="edit-modal-close-button edit-modal-fn-key-wrap edit-modal-no-drag"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleClose();
                                        }}
                                        onPointerDown={(e) => e.stopPropagation()}
                                        onTouchStart={(e) => e.stopPropagation()}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        aria-label="ESC"
                                    >
                                        <span className="edit-modal-fn-key-badge">ESC</span>
                                        <CloseIcon sx={{ fontSize: 18 }} />
                                    </button>
                                </ClearTooltip>

                                {/* Next/previous + title = drag handle only */}
                                <div
                                    className="handle edit-modal-drag-handle edit-title-container"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        margin: '0 auto',
                                        cursor: 'move',
                                    }}
                                >
                                    {/* Next arrow (only shown when editing) */}
                                    {haveNextAndPrevuios && filteredAndSortedData.length > 0 && itemEditing && currentIndex !== filteredAndSortedData.length - 1 && (
                                        <div
                                            className={`backIconBackground edit-modal-no-drag ${paStyles.navArrowBtn} ${currentIndex === filteredAndSortedData.length - 1
                                                ? 'pointer-events-disable'
                                                : ''
                                                }`}
                                            onClick={handleNext}
                                            onPointerDown={(e) => e.stopPropagation()}
                                            onTouchStart={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            aria-label={t('Next')}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="32"
                                                height="32"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9.00047 15.875L12.8805 11.995L9.00047 8.11498C8.61047 7.72498 8.61047 7.09498 9.00047 6.70498C9.39047 6.31498 10.0205 6.31498 10.4105 6.70498L15.0005 11.295C15.3905 11.685 15.3905 12.315 15.0005 12.705L10.4105 17.295C10.0205 17.685 9.39047 17.685 9.00047 17.295C8.62047 16.905 8.61047 16.265 9.00047 15.875Z"
                                                    fill="black"
                                                    fillOpacity="0.9"
                                                />
                                            </svg>
                                        </div>
                                    )}

                                    {/* Title (always visible) */}
                                    <div className="edit-title">
                                        {itemEditing
                                            ? `${t('EditReceiptPayment')} ${addEditableItem.uploadNumber}`
                                            : t('ApprovalPaymentUpload')}
                                    </div>

                                    {/* Previous arrow (only shown when editing) */}
                                    {haveNextAndPrevuios && filteredAndSortedData.length > 0 && itemEditing && currentIndex !== 0 && (
                                        <div
                                            className={`backIconBackground edit-modal-no-drag ${paStyles.navArrowBtn} ${currentIndex === 0 ? 'pointer-events-disable' : ''
                                                }`}
                                            onClick={handlePrevious}
                                            onPointerDown={(e) => e.stopPropagation()}
                                            onTouchStart={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            aria-label={t('Previous')}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="32"
                                                height="32"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M14.9995 15.875L11.1195 11.995L14.9995 8.11498C15.3895 7.72498 15.3895 7.09498 14.9995 6.70498C14.6095 6.31498 13.9795 6.31498 13.5895 6.70498L8.99953 11.295C8.60953 11.685 8.60953 12.315 8.99953 12.705L13.5895 17.295C13.9795 17.685 14.6095 17.685 14.9995 17.295C15.3795 16.905 15.3895 16.265 14.9995 15.875Z"
                                                    fill="black"
                                                    fillOpacity="0.9"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                </div>

                                {/* Toggle PDF visibility, size controls and Delete Document */}
                                <div className="edit-modal-header-actions edit-modal-no-drag">
                                    <div className="edit-modal-size-controls">
                                        <ClearTooltip title={t('Compact') || 'Compact'}>
                                            <button
                                                type="button"
                                                className={`edit-modal-size-btn ${modalSizeMode === 'compact' ? 'active' : ''}`}
                                                onClick={() => applyModalSizeMode('compact')}
                                            >
                                                S
                                            </button>
                                        </ClearTooltip>
                                        <ClearTooltip title={t('Medium') || 'Medium'}>
                                            <button
                                                type="button"
                                                className={`edit-modal-size-btn ${modalSizeMode === 'medium' ? 'active' : ''}`}
                                                onClick={() => applyModalSizeMode('medium')}
                                            >
                                                M
                                            </button>
                                        </ClearTooltip>
                                        <ClearTooltip title={t('Fullscreen') || 'Full'}>
                                            <button
                                                type="button"
                                                className={`edit-modal-size-btn ${modalSizeMode === 'expanded' ? 'active' : ''}`}
                                                onClick={() => applyModalSizeMode('expanded')}
                                            >
                                                L
                                            </button>
                                        </ClearTooltip>
                                        <ClearTooltip title={t('FreeResize') || 'Free resize'}>
                                            <button
                                                type="button"
                                                className={`edit-modal-size-btn ${modalSizeMode === 'free' ? 'active' : ''}`}
                                                onClick={() => applyModalSizeMode('free')}
                                            >
                                                <OpenWithIcon sx={{ fontSize: 14 }} />
                                            </button>
                                        </ClearTooltip>
                                        <ClearTooltip title={modalSizeMode === 'expanded' ? (t('Collapse') || 'Collapse') : (t('Expand') || 'Expand')}>
                                            <button
                                                type="button"
                                                className="edit-modal-size-icon-btn"
                                                onClick={handleToggleExpandCollapse}
                                            >
                                                {modalSizeMode === 'expanded'
                                                    ? <FullscreenExitIcon sx={{ fontSize: 18 }} />
                                                    : <FullscreenIcon sx={{ fontSize: 18 }} />}
                                            </button>
                                        </ClearTooltip>
                                    </div>

                                    {addEditableItem.receiptDocumentUrl && !isDisabledForm && itemEditing && (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            size="small"
                                            startIcon={<DeleteIcon />}
                                            onClick={handleDeleteDocumentUrl}
                                            sx={{
                                                backgroundColor: '#F44336',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                padding: '4px 12px',
                                                '&:hover': {
                                                    backgroundColor: '#d32f2f'
                                                }
                                            }}
                                        >
                                            {t('DeleteDocument')}
                                        </Button>
                                    )}

                                    {allDocUrls.length > 0 && (
                                        <IconButton onClick={handleToggleIframe}>
                                            {showPdfIframe ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    )}
                                </div>
                            </div>

                            {/* ---------- Receipt Details ---------- */}
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px', gap: '6px' }}>
                                <h3 style={{ margin: 0, fontSize: '16px' }}>{t('ReceiptDetails')}</h3>
                                {addEditableItem.deferredReceipt && (
                                    <div style={{ color: 'red', fontWeight: 'bold', fontSize: '14px' }}>
                                        ({t('DeferredReceipt')})
                                    </div>
                                )}
                            </div>

                            {/* Two even columns: every field is its own cell, so a tall field
                                cannot leave the column beside it empty. */}
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                    alignItems: 'start',
                                    columnGap: '12px',
                                    rowGap: '8px',
                                    paddingInline: '8px',
                                    boxSizing: 'border-box',
                                }}
                            >
                                {/* Payment Acceptance (Client/Provider) */}
                                <div data-ocr-field="accountCodeName">
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}> {/* Reduced margin and font size */}
                                        {addEditableItem.paymentAcceptanceType === 'תקבול'
                                            ? t('Client Name')
                                            : t('Provider Name')}
                                        <span style={{ color: 'red' }}>*</span>
                                        <FieldBoxDot field="accountCodeName" />
                                    </div>
                                    <Autocomplete
                                        className={fieldStyles.combo}
                                        options={formattedAccountCardOptions}
                                        getOptionLabel={(option) => {
                                            if (option?.value1 === 'AddItem') {
                                                return `${t('AddAccountCard')} "${option.searchTerm || searchTerm || ''}"`;
                                            }
                                            return option?.label || '';
                                        }}
                                        filterOptions={filterAccountCardOptions}
                                        value={
                                            formattedAccountCardOptions.find(
                                                (option) => option.value === addEditableItem.accountCodeId
                                            ) || null
                                        }
                                        onChange={handleMuiChangeProxy}
                                        onInputChange={(event, inputValue) => setSearchTerm(inputValue)}
                                        disablePortal={false}
                                        disableListWrap
                                        ListboxComponent={FixedSizeVirtualizedListbox}
                                        ListboxProps={{ direction, itemHeight: 40, listHeight: 320 }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className={fieldStyles.styleInput}
                                                placeholder={
                                                    addEditableItem.paymentAcceptanceType === 'תקבול'
                                                        ? t('Client Name')
                                                        : t('Provider Name')
                                                }
                                                variant="standard"
                                                required
                                                InputProps={{ ...params.InputProps, ...inputPropsStyle }}
                                                inputProps={{ ...params.inputProps, ...inputStyle }}
                                            />
                                        )}
                                        renderOption={(props, option) => {
                                            if (option?.value1 === 'AddItem') {
                                                const { key, className, ...optionProps } = props;
                                                return (
                                                    <li
                                                        key={key}
                                                        {...optionProps}
                                                        className={`${className || ''} edit-add-account-option`}
                                                    >
                                                        <AddAccountCardOptionContent
                                                            label={t('AddAccountCard')}
                                                            searchTerm={option.searchTerm || searchTerm}
                                                        />
                                                    </li>
                                                );
                                            }
                                            return (
                                                <ClearTooltip
                                                    title={
                                                        option.isEditable
                                                            ? t('RightClickToEdit')
                                                            : t('NotEditable')
                                                    }
                                                    placement="top"
                                                >
                                                    <StyledListItem
                                                        {...props}
                                                        onContextMenu={(event) => {
                                                            event.preventDefault();
                                                            setPalCode(option.palCode);
                                                            setNewAccountCard({
                                                                accountCodeName: option.name || '',
                                                                accountCodeId: option.cardId,
                                                                accountCaseId: option.accountCaseId || '',
                                                                isEditable: option.isEditable,
                                                            });
                                                            setShowAccountCardInputsEdit(true);
                                                            setAddNewAccountCardDocument(true);
                                                        }}
                                                    >
                                                        {`${option?.cardId || ''} - ${option.name}`}
                                                    </StyledListItem>
                                                </ClearTooltip>
                                            );
                                        }}
                                        PopperComponent={renderComboPopper}
                                        noOptionsText={
                                            <button
                                                type="button"
                                                className="edit-add-account-empty"
                                                onClick={() => handleNoOptionClick(searchTerm)}
                                            >
                                                <AddAccountCardOptionContent
                                                    label={t('AddAccountCard')}
                                                    searchTerm={searchTerm}
                                                />
                                            </button>
                                        }
                                        disabled={isDisabledForm}
                                    />
                                </div>
                                {/* PaymentType */}
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                        {t('PaymentType')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </div>
                                    <Autocomplete
                                        className={fieldStyles.combo}
                                        options={paymentTypeOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={
                                            paymentTypeOptions.find(
                                                (option) => option.value === addEditableItem.paymentAcceptanceType
                                            ) || null
                                        }
                                        onChange={(e, newValue) =>
                                            handleChangeAccountType(newValue ? newValue : '')
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className={fieldStyles.styleInput}
                                                variant="standard"
                                                placeholder={t('SelectPaymentType')}
                                                InputProps={{ ...params.InputProps, ...inputPropsStyle }}
                                                inputProps={{ ...params.inputProps, ...inputStyle }}
                                            />
                                        )}
                                        PopperComponent={renderComboPopper}
                                        disabled={isDisabledForm}
                                    />
                                </div>
                                {/* Document Date */}
                                <div data-ocr-field="date">
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                        {t('ReceiptPaymentDate')}
                                        <span style={{ color: 'red' }}>*</span>
                                        <FieldBoxDot field="date" />
                                    </div>
                                    <CustomDatePicker
                                        date={addEditableItem.date ? addEditableItem.date : null}
                                        onDateChange={setPaymentDate}
                                        height="40px"
                                        disabled={isDisabledLockedMetadataFields}
                                        textFieldClassName={datePickerFieldClassName}
                                        inputSx={datePickerInputSx}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                        {t('RegistrationDate')}
                                        <span style={{ color: 'red' }}>*</span>
                                    </div>
                                    <CustomDatePicker
                                        date={addEditableItem.uploadDate ? addEditableItem.uploadDate : null}
                                        onDateChange={(date) => {
                                            if (date) {
                                                handleAddEditableItemChange('uploadDate', date);
                                            }
                                        }}
                                        height="40px"
                                        disabled={isDisabledLockedMetadataFields}
                                        textFieldClassName={datePickerFieldClassName}
                                        inputSx={datePickerInputSx}
                                    />
                                </div>

                                {/* Reporting month */}
                                <div>
                                    <div className="edit-form-row-item-title" style={{ fontSize: '13px', marginBottom: '2px' }}> {t('MonthReportDate')} </div>
                                    <CustomMonthDatePicker
                                        key={reportingMonthDatePickerKey}
                                        date={
                                            addEditableItem.reportingMonthDate
                                                ? addEditableItem.reportingMonthDate
                                                : null
                                        }
                                        onDateChange={(date) => {
                                            if (date) {
                                                handleReportingMonthDateChange(date);
                                            }
                                        }}
                                        height="40px"
                                        disabled={isDisabledReportingMonthDate || isDisabledLockedMetadataFields}
                                    />
                                </div>

                                {/* Registration month */}
                                <div>
                                    <div className="edit-form-row-item-title" style={{ fontSize: '13px', marginBottom: '2px' }}> {t('RegistrationMonthDate')} </div>
                                    <CustomMonthDatePicker
                                        date={
                                            addEditableItem.registrationMonthDate
                                                ? addEditableItem.registrationMonthDate
                                                : null
                                        }
                                        onDateChange={(date) => {
                                            if (date) {
                                                handleAddEditableItemChange('registrationMonthDate', date);
                                            }
                                        }}
                                        height="40px"
                                        disabled={isDisabledLockedMetadataFields}
                                    />
                                </div>
                                {/* Foreign Currency Code + Exchange rate type + Manual rate */}
                                <div>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 4,
                                                minHeight: 22,
                                            }}
                                        >
                                            <span style={{ fontWeight: 'bold', fontSize: '13px', lineHeight: 1 }}>
                                                {t('Currency')}
                                            </span>
                                            <div
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                    height: 22,
                                                    padding: 2,
                                                    borderRadius: 3,
                                                    background: '#F8F9FA',
                                                    border: '1px solid #E9ECEF',
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                <div
                                                    onClick={() => {
                                                        if (!isDisabledForm) {
                                                            if (manualRateInput !== '' && !isNaN(Number(manualRateInput)) && Number(manualRateInput) > 0) {
                                                                lastManualRateRef.current = manualRateInput;
                                                            }
                                                            handleAddEditableItemChange('exchangeRateType', Constants.ExchangeRateType?.Representative ?? 0);
                                                            handleAddEditableItemChange('exchangeRate', null);
                                                            setManualRateInput('');
                                                        }
                                                    }}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: 22,
                                                        padding: '0 6px',
                                                        borderRadius: '3px',
                                                        cursor: isDisabledForm ? 'not-allowed' : 'pointer',
                                                        backgroundColor: !isManualRate ? '#304FFF' : 'transparent',
                                                        color: !isManualRate ? '#FFFFFF' : '#6C757D',
                                                        fontWeight: !isManualRate ? 600 : 500,
                                                        fontSize: 11,
                                                        lineHeight: 1,
                                                        whiteSpace: 'nowrap',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    {t('RepresentativeRate')}
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (!isDisabledForm) {
                                                            const restored = addEditableItem?.exchangeRate != null && addEditableItem?.exchangeRate !== ''
                                                                ? String(Number(addEditableItem.exchangeRate))
                                                                : (lastManualRateRef.current ?? calculatedManualRateFromTable ?? '');
                                                            setManualRateInput(restored);
                                                            handleAddEditableItemChange('exchangeRateType', Constants.ExchangeRateType?.Manual ?? 1);
                                                            handleAddEditableItemChange('exchangeRate', restored ? Number(restored) : null);
                                                        }
                                                    }}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: 24,
                                                        padding: '0 6px',
                                                        borderRadius: 4,
                                                        cursor: isDisabledForm ? 'not-allowed' : 'pointer',
                                                        backgroundColor: isManualRate ? '#304FFF' : 'transparent',
                                                        color: isManualRate ? '#FFFFFF' : '#6C757D',
                                                        fontWeight: isManualRate ? 600 : 500,
                                                        fontSize: 11,
                                                        lineHeight: 1,
                                                        whiteSpace: 'nowrap',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    {t('ManualRate')}
                                                </div>
                                            </div>
                                        </div>
                                        <Autocomplete
                                            className={fieldStyles.combo}
                                            options={Object.entries(Constants.ForeignCurrencyCode).map(([code, num]) => ({
                                                code,
                                                value: num,
                                                label: `${code} ${Constants.ForeignCurrencySymbol[code]}`,
                                            }))}
                                            getOptionLabel={(option) => (option && option.label) ?? ''}
                                            isOptionEqualToValue={(option, value) =>
                                                option != null && value != null && option.value === value.value
                                            }
                                            value={
                                                addEditableItem.foreignCurrencyCode != null &&
                                                addEditableItem.foreignCurrencyCode !== ''
                                                    ? (() => {
                                                          const fc = addEditableItem.foreignCurrencyCode;
                                                          const code =
                                                              typeof fc === 'string' && Constants.ForeignCurrencyCode[fc] !== undefined
                                                                  ? fc
                                                                  : Object.keys(Constants.ForeignCurrencyCode).find(
                                                                        (k) => Constants.ForeignCurrencyCode[k] === fc
                                                                    );
                                                          if (!code) return null;
                                                          const numVal = typeof fc === 'number' ? fc : Constants.ForeignCurrencyCode[code];
                                                          return {
                                                              code,
                                                              value: numVal,
                                                              label: `${code} ${Constants.ForeignCurrencySymbol[code] ?? ''}`,
                                                          };
                                                      })()
                                                    : null
                                            }
                                            onChange={(e, newVal) =>
                                                handleCurrencyCodeChange(newVal ? newVal.value : null)
                                            }
                                            disableListWrap
                                            ListboxComponent={FixedSizeVirtualizedListbox}
                                            ListboxProps={{ direction: 'rtl', itemHeight: 40, listHeight: 240 }}
                                            PopperComponent={renderComboPopper}
                                            renderInput={(params) => (
                                                <TextField
                                                    className={fieldStyles.styleInput}
                                                    {...params}
                                                    variant="standard"
                                                    placeholder={t('Currency')}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        ...inputPropsStyle,
                                                        sx: {
                                                            ...inputPropsStyle.sx,
                                                            direction: 'rtl',
                                                            border: (isManualRate && (addEditableItem.foreignCurrencyCode == null || addEditableItem.foreignCurrencyCode === ''))
                                                                ? '2px solid #d32f2f'
                                                                : undefined,
                                                        },
                                                    }}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        style: { textAlign: 'right', direction: 'rtl' },
                                                    }}
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <li
                                                    {...props}
                                                    style={{
                                                        ...(props.style || {}),
                                                        direction: 'rtl',
                                                        textAlign: 'right',
                                                    }}
                                                >
                                                    {option.label}
                                                </li>
                                            )}
                                            disabled={isDisabledForm}
                                        />
                                        {isManualRate && renderManualRateInput()}
                                    </Box>
                                </div>

                                {/* Description */}
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                        {t('ReceiptPaymentDescription')}
                                    </div>
                                    <TextField
                                        className={fieldStyles.styleInput}
                                        fullWidth
                                        type="text"
                                        placeholder={t('ReceiptPaymentDescription')}
                                        value={addEditableItem.description || ''}
                                        onChange={handleDescriptionChange}
                                        variant="standard"
                                        InputProps={inputPropsStyle}
                                        inputProps={inputStyle}
                                        disabled={isDisabledLockedMetadataFields}
                                    />
                                </div>

                                {/* Reference */}
                                <div data-ocr-field="reference">
                                    <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                        {t('Reference')}
                                        <FieldBoxDot field="reference" />
                                    </div>
                                    <TextField
                                        className={fieldStyles.styleInput}
                                        fullWidth
                                        placeholder={t('Reference')}
                                        value={addEditableItem.reference || ''}
                                        onChange={(event) =>
                                            handleAddEditableItemChange('reference', event.target.value)
                                        }
                                        variant="standard"
                                        InputProps={inputPropsStyle}
                                        inputProps={inputStyle}
                                        disabled={isDisabledForm}
                                    />
                                </div>

                                    {showProjectAssignRow && (
                                        <div>
                                            <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                                {t('Projects')}
                                            </div>
                                            <Autocomplete
                                                className={fieldStyles.combo}
                                                value={selectedProjectAutocompleteValue}
                                                onChange={handleProjectAutocompleteChange}
                                                options={projectAutocompleteOptions}
                                                getOptionLabel={(option) => option?.label ?? ''}
                                                isOptionEqualToValue={(a, b) => {
                                                    if (!a && !b) return true;
                                                    if (!a || !b) return false;
                                                    return a.kind === b.kind && String(a.id) === String(b.id);
                                                }}
                                                filterOptions={(options, state) => {
                                                    const q = state.inputValue.trim().toLowerCase();
                                                    if (!q) return options;
                                                    return options.filter(
                                                        (o) =>
                                                            o.kind === 'add' ||
                                                            o.label.toLowerCase().includes(q)
                                                    );
                                                }}
                                                disabled={isDisabledForm || projectAssignLoading || projectCreateLoading}
                                                disableListWrap
                                                ListboxComponent={FixedSizeVirtualizedListbox}
                                                ListboxProps={{ direction, itemHeight: 40, listHeight: 240 }}
                                                PopperComponent={renderComboPopper}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className={fieldStyles.styleInput}
                                                        placeholder={t('Projects')}
                                                        variant="standard"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            ...inputPropsStyle,
                                                        }}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            ...inputStyle,
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => {
                                                    if (option?.kind === 'add') {
                                                        const { key, className, style, ...optionProps } = props;
                                                        return (
                                                            <StyledListItem
                                                                {...optionProps}
                                                                key={key}
                                                                className={`${className || ''} edit-add-project-option`}
                                                                style={{
                                                                    ...(style || {}),
                                                                    textAlign: direction === 'rtl' ? 'right' : 'left',
                                                                    fontWeight: 700,
                                                                    color: '#304FFF',
                                                                    paddingTop: 8,
                                                                    paddingBottom: 8,
                                                                    paddingInline: 12,
                                                                    minHeight: 40,
                                                                    boxSizing: 'border-box',
                                                                }}
                                                            >
                                                                {option.label}
                                                            </StyledListItem>
                                                        );
                                                    }
                                                    return (
                                                        <StyledListItem
                                                            {...props}
                                                            key={props.key}
                                                            style={{
                                                                ...(props.style || {}),
                                                                textAlign: direction === 'rtl' ? 'right' : 'left',
                                                                paddingTop: 8,
                                                                paddingBottom: 8,
                                                                paddingInline: 12,
                                                                minHeight: 40,
                                                                boxSizing: 'border-box',
                                                            }}
                                                        >
                                                            {option.label}
                                                        </StyledListItem>
                                                    );
                                                }}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        backgroundColor: '#f5f5f6',
                                                    },
                                                }}
                                            />
                                        </div>
                                    )}

                                {/* Linked invoice */}
                                {cardHasPaymentTerms && (
                                    <div>
                                        <div style={{ fontWeight: 'bold', marginBottom: '2px', fontSize: '13px' }}>
                                            {t('LinkedInvoice', 'Linked Invoice')}
                                        </div>
                                        <Autocomplete
                                                className={fieldStyles.combo}
                                            freeSolo
                                            disabled={isDisabledForm}
                                            loading={isLoadingOutstandingInvoices}
                                            options={outstandingInvoices}
                                            getOptionLabel={(o) => {
                                                if (!o) return '';
                                                if (typeof o === 'string') return o;
                                                const ref = o.reference || '';
                                                const date = o.documentDate ? new Date(o.documentDate).toLocaleDateString() : '';
                                                const remaining = o.remainingAmount != null ? Number(o.remainingAmount).toLocaleString() : '';
                                                return [ref, date, remaining ? `${t('Remaining', 'Remaining')}: ${remaining}` : '']
                                                    .filter(Boolean).join(' · ');
                                            }}
                                            isOptionEqualToValue={(opt, val) =>
                                                (opt?.id && val?.id && opt.id === val.id) ||
                                                (opt?.reference && val?.reference && opt.reference === val.reference)
                                            }
                                            value={linkedInvoiceValue}
                                            onChange={(_, v) => {
                                                if (v && typeof v === 'object' && v.id) {
                                                    handleAddEditableItemChange('relatedIncomeId', v.id);
                                                    handleAddEditableItemChange('relatedInvoiceReference', v.reference || null);
                                                } else if (v && (typeof v === 'string' || v.reference)) {
                                                    handleAddEditableItemChange('relatedIncomeId', null);
                                                    handleAddEditableItemChange('relatedInvoiceReference', typeof v === 'string' ? v : v.reference);
                                                } else {
                                                    handleAddEditableItemChange('relatedIncomeId', null);
                                                    handleAddEditableItemChange('relatedInvoiceReference', null);
                                                }
                                            }}
                                            onInputChange={(_, value, reason) => {
                                                if (reason === 'input') {
                                                    handleAddEditableItemChange('relatedIncomeId', null);
                                                    handleAddEditableItemChange('relatedInvoiceReference', value || null);
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                        className={fieldStyles.styleInput}
                                                    variant="standard"
                                                    placeholder={t('LinkedInvoicePlaceholder', 'Pick or type invoice number')}
                                                    InputProps={{ ...params.InputProps, ...inputPropsStyle }}
                                                    inputProps={{ ...params.inputProps, ...inputStyle }}
                                                />
                                            )}
                                                PopperComponent={renderComboPopper}
                                                ListboxProps={{ direction }}
                                        />
                                        {selectedAccountCardForLink && (
                                            <div style={{ fontSize: 11, color: '#6C757D', marginTop: 2 }}>
                                                {t('CardHasPaymentTermsHint', 'This card has payment terms; receipts can be linked to specific invoices.')}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Status at the end, after the metadata fields */}
                                {itemEditing && canProcessStatus && (
                                        <div>
                                            <div className="edit-form-row-item-title" style={{ fontSize: '13px', marginBottom: '2px' }}>
                                                {t('status')}
                                                <span className="required-asterisk">*</span>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                            alignItems: 'stretch',
                                                    gap: '8px',
                                                    height: '40px',
                                                    minHeight: '40px',
                                                    padding: '2px',
                                                    borderRadius: '6px',
                                                    background: '#F8F9FA',
                                                    border: '1px solid #E9ECEF',
                                                    position: 'relative',
                                                    overflow: 'visible',
                                                            boxSizing: 'border-box',
                                                }}
                                            >
                                                <div
                                                    onClick={() => {
                                                        if (!isDisabledForm) {
                                                            handleRadioChange({ target: { value: 'notDone' } }, { forceProcess: false });
                                                        }
                                                    }}
                                                    style={{
                                                        flex: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '6px',
                                                                height: '100%',
                                                        padding: '0 8px',
                                                        borderRadius: '4px',
                                                        cursor: isDisabledForm ? 'not-allowed' : 'pointer',
                                                        backgroundColor: !statusCheck ? '#304FFF' : 'transparent',
                                                        color: !statusCheck ? '#FFFFFF' : '#6C757D',
                                                        fontWeight: !statusCheck ? '600' : '500',
                                                        fontSize: '12px',
                                                                lineHeight: 1,
                                                        transition: 'all 0.2s ease',
                                                        opacity: isDisabledForm ? 0.6 : 1,
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                                boxSizing: 'border-box',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isDisabledForm && statusCheck) {
                                                            e.currentTarget.style.backgroundColor = '#E3F2FD';
                                                            e.currentTarget.style.color = '#1976D2';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isDisabledForm && statusCheck) {
                                                            e.currentTarget.style.backgroundColor = 'transparent';
                                                            e.currentTarget.style.color = '#6C757D';
                                                        }
                                                    }}
                                                >
                                                    <ScheduleIcon style={{ fontSize: 16 }} />
                                                    <span>{t('unprocessed')}</span>
                                                </div>

                                                        {/* Processed Option */}
                                                        <div
                                                            className="edit-modal-fn-key-wrap"
                                                            onClick={() => {
                                                                if (!isDisabledForm) {
                                                                    handleRadioChange({ target: { value: 'done' } }, { forceProcess: forceProcess });
                                                                }
                                                            }}
                                                            style={{
                                                                flex: 1,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '6px',
                                                                height: '100%',
                                                                padding: '0 8px',
                                                                borderRadius: '4px',
                                                                cursor: isDisabledForm ? 'not-allowed' : 'pointer',
                                                                backgroundColor: statusCheck ? '#10B981' : 'transparent',
                                                                color: statusCheck ? '#FFFFFF' : '#6C757D',
                                                                fontWeight: statusCheck ? '600' : '500',
                                                                fontSize: '12px',
                                                                lineHeight: 1,
                                                                transition: 'all 0.2s ease',
                                                                opacity: isDisabledForm ? 0.6 : 1,
                                                                position: 'relative',
                                                                overflow: 'visible',
                                                                boxSizing: 'border-box',
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (!isDisabledForm && !statusCheck) {
                                                                    e.currentTarget.style.backgroundColor = '#D1FAE5';
                                                                    e.currentTarget.style.color = '#059669';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (!isDisabledForm && !statusCheck) {
                                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                                    e.currentTarget.style.color = '#6C757D';
                                                                }
                                                            }}
                                                        >
                                                            <span className="edit-modal-fn-key-badge">F1</span>
                                                            {/* Icon for Processed */}
                                                            <CheckCircleIcon style={{ fontSize: 16 }} />
                                                            <span>{t('processed')}</span>
                                                        </div>
                                                    </div>
                                                    {showForceProcessOption && (
                                                        <Box
                                                            className={`document-mode-toggle${forceProcess ? ' is-checked' : ''}`}
                                                            sx={{ mt: 1, width: 'fit-content', maxWidth: '100%' }}
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={forceProcess}
                                                                        onChange={(e) => setForceProcess(e.target.checked)}
                                                                        disabled={isDisabledForm}
                                                                        size="small"
                                                                        inputProps={{ 'aria-label': t('ForceProcess') }}
                                                                    />
                                                                }
                                                                label={t('ForceProcess')}
                                                            />
                                                        </Box>
                                                    )}
                                                </div>
                                )}

                            </div>

                            {/* -------- Divider -------- */}
                            <div
                                style={{
                                    borderTop: '1px solid #e5e7f6',
                                    margin: '6px 0', // Reduced from 20px
                                    width: '96%',
                                }}
                            />

                            {/* ---------- ADD RECEIPT ITEMS SECTION ---------- */}
                            <h3 className={paStyles.sectionTitle}>{t('ReceiptPaymentItems')}</h3>

                            {/* Add-Item Buttons (if not closed) */}
                            {!isClosedReportingMonthAndIsRange && (
                                <div className={paStyles.addItemsRow}>
                                    <Button
                                        onClick={() => handleAddItemWithSuggestedAmount('checks')}
                                        className={paStyles.addItemBtn}
                                        disabled={isDisabledForm}
                                    >
                                        {t('AddCheck')}
                                    </Button>
                                    <Button
                                        onClick={() => handleAddItemWithSuggestedAmount('creditCards')}
                                        className={paStyles.addItemBtn}
                                        disabled={isDisabledForm}
                                    >
                                        {t('AddCreditCard')}
                                    </Button>
                                    <Button
                                        onClick={() => handleAddItemWithSuggestedAmount('cash')}
                                        className={paStyles.addItemBtn}
                                        disabled={isDisabledForm}
                                    >
                                        {t('AddCash')}
                                    </Button>
                                    <Button
                                        onClick={() => handleAddItemWithSuggestedAmount('bankTransactions')}
                                        className={paStyles.addItemBtn}
                                        disabled={isDisabledForm}
                                    >
                                        {t('AddBankTransfer')}
                                    </Button>
                                    <Button
                                        onClick={() => handleAddItemWithSuggestedAmount('offsets')}
                                        className={paStyles.addItemBtn}
                                        disabled={isDisabledForm}
                                    >
                                        {t('AddOffset')}
                                    </Button>
                                    <Button
                                        onClick={withholdingRow.addRow}
                                        sx={{
                                            background: '#F9AA2A',
                                            color: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            fontSize: '13px',
                                            padding: '6px 12px',
                                            '&:hover': {
                                                background: '#E09520',
                                            },
                                            '&.Mui-disabled': {
                                                background: '#E0E0E0',
                                                color: '#BDBDBD',
                                            }
                                        }}
                                        disabled={isDisabledForm || withholdingRow.isVisible}
                                    >
                                        {t('AddWithholdingTax')}
                                    </Button>
                                </div>
                            )}
                        </div>

                        {/* ===================== RIGHT SIDE (PDF Preview) ===================== */}
                        {(showPdfIframe && allDocUrls.length > 0) && (
                            <div
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    minHeight: '300px',
                                    padding: '8px', // Reduced from 10px
                                    border: '1px solid #ddd',
                                    borderRadius: '6px', // Reduced from 8px
                                    backgroundColor: '#f9f9f9',
                                    position: 'relative',
                                }}
                            >
                                {allDocUrls.length > 1 && (
                                    <FilePreviewCarousel
                                        allDocUrls={allDocUrls}
                                        docIndex={docIndex}
                                        setDocIndex={setDocIndex}
                                        t={t}
                                    />
                                )}

                                {/* Main Document View — field boxes only on the document they were drawn on */}
                                <div style={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <DocumentPreviewWithBoxes
                                        url={allDocUrls[docIndex]}
                                        positions={fieldPositions}
                                        visibleFields={visibleFieldBoxes}
                                        activeField={activeOcrField}
                                        fieldLabels={fieldBoxLabels}
                                        fieldOrder={fieldBoxOrder}
                                        onFieldClick={handleFieldBoxClick}
                                        onBoxesShownChange={setFieldBoxesShown}
                                        renderFallback={() => (
                                            <Iframe
                                                url={
                                                    allDocUrls.length > 0
                                                        ? `${allDocUrls[docIndex]}#page=1&view=FitH`
                                                        : `${NoDocumentsPdf}#page=1&view=FitH`
                                                }
                                                width="100%"
                                                height="100%"
                                                id="receipt-pdf"
                                                title="Receipt PDF"
                                                allowFullScreen
                                                style={{
                                                    marginTop: '8px', // Reduced from 10px
                                                    borderRadius: '6px', // Reduced from 8px
                                                    border: '1px solid #ddd',
                                                    backgroundColor: '#fff',
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ===================== BOTTOM SECTION: TABLE & FOOTER BUTTONS ===================== */}
                    <div className={`${paStyles.tableSection} ${paStyles[`modal_${modalSizeMode}`] || paStyles.modal_expanded}`}>
                        {/* Amounts summary: gross − withholding = net */}
                        <PaymentAmountsSummaryBar
                            t={t}
                            amounts={amounts}
                            disabled={isDisabledForm}
                            onGrossChange={setGrossOverride}
                        />

                        <AccountCardBankDetailsBar
                            t={t}
                            direction={direction}
                            caseId={client?.caseId}
                            token={token}
                            card={selectedAccountCardForLink}
                            rows={combinedItems}
                            onFillRows={handleFillBankRowsFromCard}
                            onCardSaved={handleCardBankDetailsSaved}
                            disabled={isDisabledForm}
                        />

                        {/* Table Container */}
                        <div className={paStyles.tableWrap}>
                        <StyledTableContainer component={Paper}>
                            <StyledTable stickyHeader className={paStyles.itemsTable}>
                                <StyledTableHead>
                                    <TableRow>
                                        <StyledTableCellHeader className={paStyles.colType}>{t('Type')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colDescription}>
                                            {t('CheckNumber')} / {t('Description')}
                                        </StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colBankName}>{t('BankName')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colBankCode}>{t('BankCode')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colBankBranch}>{t('BankBranchCode')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colBankAccount}>{t('BankAccountNumber')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colAmount}>{t('Amount')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colCurrencyAmount}>{t('CurrencyAmount')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colReference2}>{t('Reference2')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colDueDate}>{t('DuePaymentDate')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colAccount}>{t('Debit Account')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colAccount}>{t('Credit Account')}</StyledTableCellHeader>
                                        <StyledTableCellHeader className={paStyles.colActions}>{t('Actions')}</StyledTableCellHeader>
                                    </TableRow>
                                </StyledTableHead>
                                <TableBody>
                                    {renderTableRows()}
                                    {withholdingRow.isVisible && (
                                        <PaymentWithholdingTaxRow
                                            t={t}
                                            direction={direction}
                                            inputPropsStyle={inputPropsStyle}
                                            inputStyle={inputStyle}
                                            disabled={isDisabledForm}
                                            {...withholdingRow.rowProps}
                                        />
                                    )}
                                </TableBody>
                            </StyledTable>
                        </StyledTableContainer>
                        </div>

                        {/* Footer Buttons */}
                        <div className="form-row edit-modal-actions-row">
                            {/* Actions */}
                            {itemEditing && (
                                <div className="edit-form-row-item edit-modal-actions-col">
                                    <div className="edit-form-row-item-title">
                                        {t('Actions')}
                                    </div>
                                    <div
                                        className="edit-modal-actions-bar"
                                        style={{
                                            opacity: isDisabledForm ? 0.45 : 1,
                                            pointerEvents: isDisabledForm ? 'none' : 'auto',
                                        }}
                                    >

                                        {userTypeContext?.toString() !== Constants.UserType.Client &&
                                            <>
                                                <ClearTooltip title={t('SendToChat')}>
                                                    <IconButton
                                                        disabled={isDisabledForm}
                                                        onClick={handleSendToChat}
                                                        size="small"
                                                    >
                                                        <span style={{ display: 'flex', alignItems: 'center', color: '#4CAF50' }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#4CAF50">
                                                                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM7 9H17V11H7V9ZM7 12H14V14H7V12Z" />
                                                            </svg>
                                                        </span>
                                                    </IconButton>
                                                </ClearTooltip>

                                                <ClearTooltip title={t('AttachDocument')}>
                                                    <IconButton
                                                        disabled={isDisabledForm}
                                                        onClick={() => setUploadModalOpen(true)}
                                                        size="small"
                                                    >
                                                        <AttachFileIcon sx={{ color: '#2196F3' }} />
                                                    </IconButton>
                                                </ClearTooltip>

                                                {itemEditing && (
                                                    <ClearTooltip title={t('DuplicatePayment')}>
                                                        <IconButton
                                                            disabled={isDisabledForm}
                                                            onClick={openDuplicate}
                                                            size="small"
                                                        >
                                                            <ContentCopyIcon sx={{ color: '#9C27B0', fontSize: '20px' }} />
                                                        </IconButton>
                                                    </ClearTooltip>
                                                )}
                                            </>
                                        }

                                        {(userTypeContext?.toString() !== Constants.UserType.Client ||
                                            permissionsState.Premium) && (
                                                <>
                                                    <ClearTooltip title={t('Delete')}>
                                                        <IconButton
                                                            disabled={isDisabledForm}
                                                            onClick={() => handleDeleteClick(addEditableItem.id)}
                                                            size="small"
                                                        >
                                                            <DeleteIcon style={{ color: '#fa0a1e', fontSize: '20px' }} /> {/* Reduced size */}
                                                        </IconButton>
                                                    </ClearTooltip>

                                                    <DocumentTransferDialog
                                                        editedItem={addEditableItem}
                                                        token={token}
                                                        setLoading={setLoading}
                                                        RefreshPage={handleTransferRefresh}
                                                        t={t}
                                                        client={client}
                                                        clarificationRestoreMode={!!addEditableItem?.clarificationId}
                                                    />

                                                    {isLocked ? (
                                                        <ClearTooltip title={t('Locked')}>
                                                            <LockIcon style={{ color: '#6c757d', cursor: 'default', fontSize: '20px' }} /> {/* Reduced size */}
                                                        </ClearTooltip>
                                                    ) : (
                                                        <ClearTooltip title={t('LockDocument')}>
                                                            <IconButton
                                                                onClick={async () => {
                                                                    if (!statusCheck) {
                                                                        toast.warning(t('MarkAsProcessedBeforeLocking'), { autoClose: 3000 });
                                                                        return;
                                                                    }
                                                                    const result = await Swal.fire({
                                                                        title: t('AreYouSure'),
                                                                        text: t('OnceLockedYouCannotEditOrDelete'),
                                                                        icon: 'warning',
                                                                        showCancelButton: true,
                                                                        confirmButtonColor: '#3085d6',
                                                                        cancelButtonColor: '#d33',
                                                                        confirmButtonText: t('YesLockIt'),
                                                                        cancelButtonText: t('NoCancel'),
                                                                        customClass: {
                                                                            container: 'swal-high-zindex'
                                                                        }
                                                                    });

                                                                    if (result.isConfirmed) {
                                                                        try {
                                                                            setLoading(true);
                                                                            const res = await DocumentService.LockDocument(addEditableItem.id, client.caseId, token);
                                                                            if (res.ok) {
                                                                                toast.success(t('DocumentLocked'));
                                                                                handleTransferRefresh();
                                                                            } else {
                                                                                const errorText = await res.text();
                                                                                toast.error(t('LockFailed', { errorText }));
                                                                            }
                                                                        } catch (err) {
                                                                            toast.error(t('LockFailed', { errorText: err.message }));
                                                                        } finally {
                                                                            setLoading(false);
                                                                        }
                                                                    }
                                                                }}
                                                                size="small"
                                                            >
                                                                <LockIcon style={{ color: '#d32f2f', fontSize: '20px' }} /> {/* Reduced size */}
                                                            </IconButton>
                                                        </ClearTooltip>
                                                    )}
                                                </>
                                            )}
                                    </div>
                                </div>
                            )}

                            {/* Navigation and Save Buttons */}
                            <div className="edit-form-row-item edit-modal-nav-col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                <div className="edit-navigation-container">
                                    {/* Next Button - Only in edit mode */}
                                    {itemEditing && currentIndex !== null && currentIndex > -1 && currentIndex !== filteredAndSortedData.length - 1 && (
                                        <div className="edit-nav-button-wrapper">
                                            <div
                                                className={`edit-nav-button edit-modal-fn-key-wrap ${currentIndex === filteredAndSortedData.length - 1 ? 'disabled' : ''}`}
                                                onClick={handleNext}
                                            >
                                                <span className="edit-modal-fn-key-badge">F3</span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M9.00047 15.875L12.8805 11.995L9.00047 8.11498C8.61047 7.72498 8.61047 7.09498 9.00047 6.70498C9.39047 6.31498 10.0205 6.31498 10.4105 6.70498L15.0005 11.295C15.3905 11.685 15.3905 12.315 15.0005 12.705L10.4105 17.295C10.0205 17.685 9.39047 17.685 9.00047 17.295C8.62047 16.905 8.61047 16.265 9.00047 15.875Z"
                                                        fill="black"
                                                        fillOpacity="0.9"
                                                    />
                                                </svg>
                                            </div>
                                            <span className="edit-button-label">
                                                {t('Next')}
                                            </span>
                                        </div>
                                    )}

                                    {/* Save Button - Centered */}
                                    <div className="edit-nav-button-wrapper">
                                        <ClearTooltip
                                            title={
                                                (isSaveBlocked || isSaveDisabled) && validationResult.length > 0
                                                    ? `${t('PleaseFillRequiredFields')}: ${validationResult.join(', ')}`
                                                    : `${t('Save')} (F2)`
                                            }
                                            placement="top"
                                        >
                                            <div
                                                className={`edit-modal-save-button edit-modal-fn-key-wrap ${isSaveBlocked || isSaveDisabled ? 'disabled' : ''}`}
                                                onClick={(isSaveBlocked || isSaveDisabled) ? undefined : (itemEditing ? handleSave : handleClickDoneCreation)}
                                                style={{
                                                    cursor: (isSaveBlocked || isSaveDisabled) ? 'not-allowed' : 'pointer',
                                                    opacity: (isSaveBlocked || isSaveDisabled) ? 0.6 : 1,
                                                }}
                                            >
                                                <span className="edit-modal-fn-key-badge">F2</span>
                                                <span className="edit-modal-save-button-text">
                                                    {t('Save')}
                                                </span>
                                            </div>
                                        </ClearTooltip>
                                        <span className="edit-button-label">
                                            {t('Save')}
                                        </span>
                                    </div>

                                    {/* Previous Button - Only in edit mode */}
                                    {itemEditing && currentIndex !== null && currentIndex > -1 && currentIndex !== 0 && (
                                        <div className="edit-nav-button-wrapper">
                                            <div
                                                className={`edit-nav-button edit-modal-fn-key-wrap ${currentIndex === 0 ? 'disabled' : ''}`}
                                                onClick={handlePrevious}
                                            >
                                                <span className="edit-modal-fn-key-badge">F4</span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M14.9995 15.875L11.1195 11.995L14.9995 8.11498C15.3895 7.72498 15.3895 7.09498 14.9995 6.70498C14.6095 6.31498 13.9795 6.31498 13.5895 6.70498L8.99953 11.295C8.60953 11.685 8.60953 12.315 8.99953 12.705L13.5895 17.295C13.9795 17.685 14.6095 17.685 14.9995 17.295C15.3795 16.905 15.3895 16.265 14.9995 15.875Z"
                                                        fill="black"
                                                        fillOpacity="0.9"
                                                    />
                                                </svg>
                                            </div>
                                            <span className="edit-button-label">
                                                {t('Previous')}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* Document Processed By Information */}
                                {addEditableItem?.processedBy && subAccountantNewOptions.length > 0 && (
                                    <div
                                        style={{
                                            marginTop: '5px',
                                            padding: '4px 6px',
                                            backgroundColor: '#304FFF',
                                            borderRadius: '6px',
                                            border: '1px solid #304FFF',
                                            fontSize: '14px',
                                            color: '#ffffff',
                                            textAlign: 'center',
                                            width: '100%',
                                            boxSizing: 'border-box !important',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('DocumentProcessedBy')}: {(() => {
                                            const foundOption = subAccountantNewOptions.find(option => option.value === addEditableItem.processedBy);
                                            if (foundOption?.label) {
                                                return foundOption.label;
                                            } else if (addEditableItem.processedBy === "-100") {
                                                return t('ProcessedBySystem');
                                            } else {
                                                return addEditableItem.processedBy;
                                            }
                                        })()}
                                    </div>
                                )}
                                {/* Document Created By Information */}
                                {(addEditableItem?.createdByUserId || addEditableItem?.createdByUserType) && (
                                    <div
                                        style={{
                                            marginTop: '5px',
                                            padding: '4px 6px',
                                            backgroundColor: '#2E7D32',
                                            borderRadius: '6px',
                                            border: '1px solid #2E7D32',
                                            fontSize: '14px',
                                            color: '#ffffff',
                                            textAlign: 'center',
                                            width: '100%',
                                            boxSizing: 'border-box !important',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('DocumentCreatedBy')}: {(() => {
                                            if (subAccountantNewOptions?.length > 0 && addEditableItem.createdByUserId) {
                                                const foundOption = subAccountantNewOptions.find(option => option.value === addEditableItem.createdByUserId);
                                                if (foundOption?.label) return foundOption.label;
                                            }
                                            if (addEditableItem.createdByUserType === 'Client') return t('Client');
                                            if (addEditableItem.createdByUserId && addEditableItem.createdByUserType) return `${addEditableItem.createdByUserId} (${addEditableItem.createdByUserType})`;
                                            return addEditableItem.createdByUserId || addEditableItem.createdByUserType || '—';
                                        })()}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="edit-modal-resize-handle edge-e" onMouseDown={beginResize('e')} />
                    <div className="edit-modal-resize-handle edge-s" onMouseDown={beginResize('s')} />
                    <div className="edit-modal-resize-handle edge-se" onMouseDown={beginResize('se')} />
                    <div className="edit-modal-resize-handle edge-sw" onMouseDown={beginResize('sw')} />
                    <div className="edit-modal-resize-handle edge-w" onMouseDown={beginResize('w')} />
                </div>
            </Draggable>

            {/* MODAL: BulkEditModal for Duplicate */}
            {dupOpen && (
                <BulkEditModal
                    duplicateMode={true}
                    open={dupOpen}
                    ids={[addEditableItem.id]}
                    sourceTransaction={addEditableItem}
                    onClose={closeDuplicate}
                    onSavePatch={saveDuplicate}
                    formattedAccountCardOptions={formattedAccountCardOptions2}
                    sortCodeIdOptions={sortCodeIdOptions}
                    client={client}
                    accountCardOptions={accountCardOptions}
                    type="PaymentAcceptances"
                    token={token}
                />
            )}

            {/* MODAL: AddAccountCardModal */}
            <AddAccountCardModal
                accountCardOptions={accountCardOptions}
                open={addNewAccountCardDocument}
                onClose={handleCloseItem}
                editedItem={newAccountCard}
                isEdit={showAccountCardInputsEdit}
                isRange={isRange}
                isClosedReportingMonth={isClosedReportingMonth}
                palCodes={Constants.AccountCardPalCode}
                propPalCode={palCode}
                setPalCode={setPalCode}
                direction={direction}
                isAdd={!showAccountCardInputsEdit}
                client={client}
                token={token}
                setLoading={setLoading}
                handleChangeAfterAdd={handleChangeAfterAdd}
                fetchEnums={fetchEnums}
                type={addAccountCardType}
            />

            {/* File Upload Modal */}
            {uploadModalOpen && (
                <Portal>
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1400,
                        }}
                        onClick={() => {
                            setUploadModalOpen(false);
                            setDocuments([]);
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                padding: '24px',
                                minWidth: '500px',
                                maxWidth: '600px',
                                maxHeight: '80vh',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                                direction: direction,
                            }}
                        >
                            {/* Header */}
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                marginBottom: '20px'
                            }}>
                                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                                    {t('AttachDocument')}
                                </h2>
                                <IconButton
                                    onClick={() => {
                                        setUploadModalOpen(false);
                                        setDocuments([]);
                                    }}
                                    size="small"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>

                            {/* File Upload Section */}
                            <div
                                className="newDocument-file-upload-container input-field_Container_required-asterisk edit-attach-dropzone"
                                {...getRootProps()}
                            >
                                <DropZoneContainer isDragActive={isDragActive} style={{ width: '100%', minHeight: '120px' }}>
                                    <input {...getInputProps()} />

                                    {/* Show message when dragging */}
                                    {isDragging && (
                                        <DragOverlayText style={{ display: 'block' }}>
                                            {t('DropFilesHere')}
                                        </DragOverlayText>
                                    )}

                                    {!isDragging && (
                                        <label className="newDocument-upload-label">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="upload-icon"
                                                viewBox="0 0 58 58"
                                                fill="none"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M29 38.0625C30.001 38.0625 30.8125 37.251 30.8125 36.25V9.73298L34.874 14.4712C35.5253 15.2313 36.6696 15.3193 37.4296 14.6678C38.1896 14.0164 38.2776 12.8721 37.6261 12.1121L30.3761 3.65378C30.0319 3.25204 29.529 3.02084 29 3.02084C28.471 3.02084 27.9681 3.25204 27.624 3.65378L20.3739 12.1121C19.7224 12.8721 19.8104 14.0164 20.5705 14.6678C21.3305 15.3193 22.4747 15.2313 23.1262 14.4712L27.1875 9.73298V36.25C27.1875 37.251 27.999 38.0625 29 38.0625Z"
                                                    fill="#F9AA2A"
                                                />
                                            </svg>
                                            <span className="upload-text">
                                                {documents?.length > 0
                                                    ? documents.map((doc) => doc.name).join(', ')
                                                    : t('DragDropFilesOrClick')}
                                            </span>
                                        </label>
                                    )}
                                </DropZoneContainer>
                            </div>

                            {/* Documents List */}
                            {documents.length > 0 && (
                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        fontWeight: 'bold', 
                                        marginBottom: '10px',
                                        color: '#333'
                                    }}>
                                        {t('SelectedFiles')} ({documents.length})
                                    </div>
                                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        {documents.map((doc, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '8px 12px',
                                                    marginBottom: '8px',
                                                    backgroundColor: '#F5F5F6',
                                                    borderRadius: '6px',
                                                }}
                                            >
                                                <span style={{ fontSize: '13px', color: '#333' }}>
                                                    {doc.name}
                                                </span>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRemoveDocument(index)}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div style={{ 
                                display: 'flex', 
                                marginTop: '20px',
                                gap: '12px', 
                                justifyContent: 'flex-end' 
                            }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setUploadModalOpen(false);
                                        setDocuments([]);
                                    }}
                                    style={{
                                        borderColor: '#ccc',
                                        color: '#666',
                                    }}
                                >
                                    {t('cancel')}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleUploadDocuments}
                                    disabled={documents.length === 0}
                                    style={{
                                        backgroundColor: documents.length === 0 ? '#ccc' : '#304FFF',
                                        color: 'white',
                                    }}
                                >
                                    {t('Upload')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Portal>
            )}

            {projectModalOpen && (
                <Portal container={projectModalPortalContainer}>
                    <ProjectModal
                        open={projectModalOpen}
                        mode="create"
                        direction={direction}
                        formData={{ code: '', name: '' }}
                        existingProjects={segmentationProjects}
                        onClose={handleProjectModalClose}
                        onSave={handleProjectModalSave}
                        loading={projectCreateLoading}
                        zIndex={1400}
                    />
                </Portal>
            )}
            </FieldBoxDotProvider>
        </Portal>
    );
};

export default PaymentAcceptanceCreateEditModal;
